import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy, NgZone  } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { latLng, tileLayer } from 'leaflet';
import { ToastrService } from 'ngx-toastr';

import { Board } from 'src/app/core/models/board.model';
import { BoardStats } from 'src/app/core/models/boardStats.model';
import { SalesRep } from 'src/app/core/models/sales-rep.model';
import { Location } from 'src/app/core/models/location.model';
import { Invoice } from 'src/app/core/models/invoice.model';
import { UserType } from 'src/app/core/models/userType.models';
import { UserService } from 'src/app/core/services/user.service'; // adjust path as needed

import { BoardService } from 'src/app/core/services/board.service';
import { BoardStatService, GroupedStats } from 'src/app/core/services/boardstats.service';
import { LocationService } from 'src/app/core/services/location.service';
import { SalesRepService } from 'src/app/core/services/sales-rep.service';
import { LoginService } from 'src/app/core/services/login.service';
import { InvoiceService } from 'src/app/core/services/invoice.service';

import { BoardStatsByIdComponent } from 'src/app/pages/boardStatsById/boardStatsById.component';
import { BoardStatsReportComponent } from '../board-stats-report/board-stats-report.component';
import { jsPDF } from 'jspdf';
import { PaymentService } from 'src/app/core/services/payment.service';
import { Payment } from 'src/app/core/models/payment.model';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Title } from '@angular/platform-browser';
import { User } from 'src/app/core/models/user.model'; // or wherever your User type is
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { BoardGameStats } from 'src/app/core/models/boardGameStats.model';
import { BoardGameStatsService } from 'src/app/core/services/boardGameStats.service';
import { FusionConnectDailyStat, FusionConnectGameMeterRow } from 'src/app/core/models/fusion-connect.model';
import { PaymentSummary } from 'src/app/core/models/payment-summary.model';
import { LeadService } from 'src/app/core/services/lead.service';
import { FusionConnectService } from 'src/app/core/services/fusion-connect.service';
import { LeadDTO } from 'src/app/core/models/lead.model';
import { LeadModalComponent } from 'src/app/pages/dashboard/lead-modal/lead-modal.component';
import { firstValueFrom, forkJoin, of } from 'rxjs';
import { GameAggregateStats } from 'src/app/core/models/game-aggregate-stats.model';
import { GameStatsBreakdown } from 'src/app/core/models/game-stats-breakdown.model';
import { GameBoardBreakdown } from 'src/app/core/models/game-board-breakdown.model';
import { GameStatsDetails } from 'src/app/core/models/game-stats-details.model';
import { GroupedGameStatsBreakdown } from 'src/app/core/models/game-stats-grouped.model';
import { map, catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexStroke,
  ApexDataLabels,
  ApexMarkers,
  ApexXAxis,
  ApexYAxis,
  ApexTooltip,
  ApexLegend
} from 'ng-apexcharts';


// Top-level type alias (NOT inside @Component, NOT inside the class)
type BoardStatsWithRaw = BoardStats & {
  __rawTs?: string;
  __serial?: string;
  __locationName?: string;
  __salesRepName?: string;
  __salesRepId?: string;
  __state?: string;
  __isWarehouse?: boolean;
};



@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush 
  

})

export class DashboardComponent implements OnInit {
  dashboardView: 'fortune' | 'fusionLease' | 'boardSales' = 'fortune';
  operationTable: 'stats' | 'contracts' | 'machines' | null = null;
  private readonly moveToFusionLeaseNote = '__MOVE_TO_FUSION_LEASE__';
  private readonly moveToPickupNote = '__MOVE_TO_PICKUP__';
  @ViewChild('paymentHistoryModal') paymentHistoryModal!: TemplateRef<any>;
  @ViewChild('locationEndDatesModal') locationEndDatesModal!: TemplateRef<any>;

  // Search and filtering
  term: string = '';
  boardSearchTerm: string = '';
  liveTerm: string = '';
  liveBoardSearchTerm: string = '';
  locationSearchTerm: string = '';
  boardStats!: BoardStatsWithRaw[];
  filteredStats!: BoardStatsWithRaw[];
  boardStatsLoaded = false;
  boardStatsLoading = false;
  boardStatsCardLoading = true;
  dashboardStatsCount = 0;
  dashboardFlaggedStatsCount = 0;
  fusionLeaseSummary = { cashIn: 0, net: 0, rows: 0 };
  pickupSummary = { cashIn: 0, net: 0, rows: 0 };
  boardSalesSummary = { cashIn: 0, net: 0, rows: 0 };
  filteredSalesReps: Map<string, SalesRep> = new Map();
  filteredSalesRepsArray: SalesRep[] = [];
  selectedSalesRep: SalesRep | null = null;
  liveSelectedSalesRep: SalesRep | null = null;
  currentSalesRep: SalesRep | null = null;
  activeFilterContext: 'regular' | 'live' = 'regular';
  filteredBoards!: Board[];
  filteredLocation: Location[] = [];
  filteredLocations: Location[] = [];
  lostInventoryLocation: Location | null = null;
  lostInventoryBoardCount: number = 0;
  locationCityFilter: string = '';
  locationStateFilter: string = '';
  locationMinMachines: number | null = null;
  locationSortColumn: 'machines' | 'city' | 'state' | '' = '';
  locationSortAsc: boolean = true;
  filteredNewLocations: Location[] = [];
  boardInventoryLocations: Location[] = [];
  boardInventoryTypeCounts: Record<string, number> = {};
  boardInventoryTypeCountsByLocation: Record<string, Record<string, number>> = {};
  boardStatsByGame!: Map<string, GroupedStats>;
  selectedLocation: Location | null = null;
  locationBoardStats: BoardStats[] = [];
  isLoadingLocationStats: boolean = false;
  paymentForm: FormGroup;
  paymentAmounts: { [key: string]: number } = {};
  paymentHistory: any[] = [];
  currentMonthPayments: { [key: string]: Payment[] } = {}
  selectedSalesRepLocations: Location[] = [];
  daysInMonth: number = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
  customDays: { [key: string]: number } = {};
  isFreeMonth: { [repId: string]: boolean } = {};
  currentUserType: string = '';
  selectedBoardAssetTag: string | null = null;
  boardGameStatsList: BoardGameStats[] = [];
  isLoadingGameStats = false;
  allSalesReps: SalesRep[] = [];
  paymentSummaries: PaymentSummary[] = [];
  totalPaid: { [repId: string]: number } = {};
  filteredLeads: LeadDTO[] = [];
  fortuneLiveStats: FusionConnectDailyStat[] = [];
  statuses: string[] = ['NEW', 'CONTACTED', 'IN_PROGRESS', 'WON', 'LOST'];
  filterStatus: string = '';
  activeGameTab: string = 'byGame';
  startDate: Date = new Date();
  endDate: Date = new Date();
  topGame: GameAggregateStats | null = null;
  topGameName: string | null = null;
  topGamePerDay: { gameName: string; avg: number } | null = null;
  showTopGameStats: boolean = false; // if not already declared
  packageByGame: Record<string, string> = {};
  pkgByAssetTag: Record<string, string> = {};
  cleanTotalsByGame: Record<string, { coinIn: number; coinOut: number; net: number }> = {};
  isDeleting: Record<string, boolean> = {};
  private packageAliasByNormKey: Record<string, string> = {
    'world of wonders': 'WORLD OF WONDERS',
    'fortune ip three liner': 'FORTUNE IP THREE LINER'
  };
  

  showGameStatsModal = false;
  allTopGameStats: GameAggregateStats[] = [];
  topGameStats: GameAggregateStats[] = [];
  selectedFlatBreakdowns: { [gameName: string]: GameStatsBreakdown[] } = {};
  selectedGroupedBreakdowns: { [gameName: string]: GroupedGameStatsBreakdown[] } = {};

  expandedGameName: string | null = null;
  boardSummariesByGame: { [gameName: string]: GameBoardBreakdown[] } = {};
  readBreakdownsByBoard: { [boardTag: string]: GameStatsDetails[] } = {};
  expandedBoards: Set<string> = new Set();
  groupedGameStats: { boardKey: string; summary: GameStatsDetails; details: GameStatsDetails[]; expanded: boolean }[] = [];
  selectedState: string | null = null;
  liveSelectedState: string | null = null;
  states: string[] = [];
  // Store the untouched rows (optional cache)
  private _allBoardStatsRaw: BoardStatsWithRaw[] = [];


  // UI state
  showStats = false;
  showFortuneLiveStats = false;
  showFortuneLiveTestStats = false;
  showGameStats = false;
  showLocationPage = false;
  showWarehousePage = false;
  showBoardInventoryPage = false;
  showNewLocationPage = false;
  showSalesOutletPage = false;
  showStatsReport = false
  showTable = false;
  showStatsDashboardPage = false;
  showCard = true;
  isLoading = false
  showLeadModal = false;
  totalLeads: number = 0; // fetched from backend
  showLeadsTable: boolean = false;
  showLeadsPage: boolean = false;
  salesOutletBoardPrice = 1500;

  // Guards refresh cycles so stale responses cannot overwrite the newest Top Game state
  private topGameLoadId = 0;



  // Card visibility controls
  showDashBoardCard = {
    lastWeeksInstallation: true,
    totalMachieCount: true,
    machineAvaiableDeploy: true,
    boardInventory: true,
    monthlyRevenue: true,
    lastWeekInstallation: true, 
    totalLeads: true,  // <-- add this
    topGame: true,  // âœ… add this line
    salesOutlet: true
  };

showCardStats = {
  cashInPerDay: true,
  netPerDay: true,
  liveKonnectStats: true,
  gameStats: true,
  detailedGameStats: true,
  topGame: false
};

rptGamesSeries: ApexAxisChartSeries = [];
rptTopGamesSeries: ApexAxisChartSeries = [];

rptGamesChartOptions: {
  chart: ApexChart;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  legend: ApexLegend;
} = {
  chart: { type: 'line', height: 380, zoom: { enabled: true }, toolbar: { show: true } },
  stroke: { width: 3, curve: 'smooth' },
  dataLabels: { enabled: false },
  markers: { size: 4 },
  xaxis: {
    type: 'numeric',
    title: { text: 'Cumulative Games Played' },
    labels: {
      formatter: (v: string | number) => {
        const num = Number(v);
        if (!Number.isFinite(num)) return '';
        return num >= 1000 ? `${(num / 1000).toFixed(0)}k` : `${Math.round(num)}`;
      }
    }
  },
  yaxis: {
    title: { text: 'RPT (coinOut / coinIn)' },
    decimalsInFloat: 2,
    labels: { formatter: (v: string | number) => `${(Number(v) * 100).toFixed(1)}%` }
  },
  tooltip: {
    shared: false,
    y: {
      formatter: (val: number) => `${(val * 100).toFixed(2)}%`
    },
    custom: ({ series, seriesIndex, dataPointIndex, w }) => {
      const point = (w?.config?.series?.[seriesIndex]?.data as any)?.[dataPointIndex] || {};
      const games = point?.x ?? w?.globals?.seriesX?.[seriesIndex]?.[dataPointIndex];
      const gamesLabel =
        Number.isFinite(games) && games >= 1000
          ? `${(games / 1000).toFixed(0)}k`
          : Number.isFinite(games)
            ? `${Math.round(games)}`
            : '';

      const dateLabel =
        point?.dateLabel ||
        (point?.ts
          ? new Date(point.ts).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
          : '');

      const rptVal = series?.[seriesIndex]?.[dataPointIndex];
      const rptText = Number.isFinite(rptVal) ? `${(Number(rptVal) * 100).toFixed(2)}%` : '';
      const seriesName = w?.globals?.seriesNames?.[seriesIndex] || '';

      return `
        <div class="apex-tooltip">
          ${gamesLabel ? `<div>${gamesLabel} games</div>` : ''}
          ${dateLabel ? `<div>${dateLabel}</div>` : ''}
          <div>${seriesName}: ${rptText}</div>
        </div>
      `;
    }
  },
  legend: { show: true }
};

showRptChart = false;
  showTopGamesChart = false;
  showFusionLeaseStats = false;
  showPickupLocationStats = false;
  showBoardSalesStats = false;
  readonly fusionLeaseSalesReps = [
    'Nestor Sanchez',
    'Andy Vasvani',
    'Amin Popatiya',
    'RAFIQ MERCHANT',
    'Nahinur Rahman',
    'SULEMAN SUKHIANY',
    'Peter Patel'
  ];
  readonly pickupLocations = [
    'Team Azad',
    'Rocky Virgina',
    'AJU TEAM',
    'Team Azad TN',
    'RO',
    'ROCKY TN',
    'Team AJU TN'
  ];

topGamesChartOptions: {
  chart: ApexChart;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  legend: ApexLegend;
} = {
  chart: { type: 'line', height: 380, zoom: { enabled: true }, toolbar: { show: true } },
  stroke: { width: 3, curve: 'smooth' },
  dataLabels: { enabled: false },
  markers: { size: 4 },
  xaxis: {
    type: 'numeric',
    title: { text: 'Cumulative Games Played' },
    labels: {
      formatter: (v: string | number) => {
        const num = Number(v);
        if (!Number.isFinite(num)) return '';
        return num >= 1000 ? `${(num / 1000).toFixed(0)}k` : `${Math.round(num)}`;
      }
    }
  },
  yaxis: {
    title: { text: 'RPT (coinOut / coinIn)' },
    decimalsInFloat: 2,
    labels: { formatter: (v: string | number) => `${(Number(v) * 100).toFixed(1)}%` }
  },
  tooltip: {
    shared: false,
    y: {
      formatter: (val: number) => `${(val * 100).toFixed(2)}%`
    },
    custom: ({ series, seriesIndex, dataPointIndex, w }) => {
      const point = (w?.config?.series?.[seriesIndex]?.data as any)?.[dataPointIndex] || {};
      const games = point?.x ?? w?.globals?.seriesX?.[seriesIndex]?.[dataPointIndex];
      const gamesLabel =
        Number.isFinite(games) && games >= 1000
          ? `${(games / 1000).toFixed(0)}k`
          : Number.isFinite(games)
            ? `${Math.round(games)}`
            : '';

      const dateLabel =
        point?.dateLabel ||
        (point?.ts
          ? new Date(point.ts).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
          : '');

      const rptVal = series?.[seriesIndex]?.[dataPointIndex];
      const rptText = Number.isFinite(rptVal) ? `${(Number(rptVal) * 100).toFixed(2)}%` : '';
      const seriesName = w?.globals?.seriesNames?.[seriesIndex] || '';

      return `
        <div class="apex-tooltip">
          ${gamesLabel ? `<div>${gamesLabel} games</div>` : ''}
          ${dateLabel ? `<div>${dateLabel}</div>` : ''}
          <div>${seriesName}: ${rptText}</div>
        </div>
      `;
    }
  },
  legend: { show: true }
};
  
toggleTable(tableName: string) {
  const isAlreadyOpen =
    (tableName === 'stats' && this.showStats) ||
    (tableName === 'fortuneLiveStats' && this.showFortuneLiveStats) ||
    (tableName === 'fortuneLiveTestStats' && this.showFortuneLiveTestStats) ||
    (tableName === 'gameStats' && this.showGameStats) ||
    (tableName === 'location' && this.showLocationPage) ||
    (tableName === 'warehouse' && this.showWarehousePage) ||
    (tableName === 'newLocation' && this.showNewLocationPage) ||
    (tableName === 'boardInventory' && this.showBoardInventoryPage) ||
    (tableName === 'salesOutlet' && this.showSalesOutletPage) ||
    (tableName === 'revenue' && this.showTable) ||
    (tableName === 'leads' && this.showLeadsPage && this.showLeadsTable) ||
    (tableName === 'topGameStats' && this.showTopGameStats) ||
    (tableName === 'rptChart' && this.showRptChart) ||
    (tableName === 'topGamesChart' && this.showTopGamesChart) ||
    (tableName === 'fusionLeaseStats' && this.showFusionLeaseStats) ||
    (tableName === 'pickupLocationStats' && this.showPickupLocationStats) ||
    (tableName === 'boardSalesStats' && this.showBoardSalesStats);
  if (isAlreadyOpen) {
    this.closeAllTables();
    return;
  }

  this.closeAllTables();

  switch (tableName) {
    case 'stats':
      this.showStats = true;
      void this.ensureBoardStatsLoaded();
      break;
    case 'fortuneLiveStats':
      this.showFortuneLiveStats = true;
      break;
    case 'fortuneLiveTestStats':
      this.showFortuneLiveTestStats = true;
      break;
    case 'gameStats':
      this.showGameStats = true;
      this.activeGameTab = 'byState';
      break;
    case 'location':
      this.showLocationPage = true;
      this.scrollToSection('location-management-section');
      break;
    case 'warehouse':
      this.showWarehousePage = true;
      break;
    case 'boardInventory':
      this.showBoardInventoryPage = true;
      break;
    case 'newLocation':
      this.showNewLocationPage = true;
      break;
    case 'salesOutlet':
      this.showSalesOutletPage = true;
      break;
    case 'revenue':
      this.showTable = true;
      break;
    case 'leads':
      this.showLeadsPage = true;
      this.showLeadsTable = true;
      break;
    case 'topGameStats':
      this.showTopGameStats = true;
      break;
    case 'rptChart':
      this.showRptChart = true;
      break;
    case 'topGamesChart':
      this.showTopGamesChart = true;
      break;
    case 'fusionLeaseStats':
      this.showFusionLeaseStats = true;
      void this.ensureBoardStatsLoaded();
      break;
    case 'pickupLocationStats':
      this.showPickupLocationStats = true;
      break;
    case 'boardSalesStats':
      this.showBoardSalesStats = true;
      void this.ensureBoardStatsLoaded();
      break;
  }
}

private scrollToSection(elementId: string): void {
  setTimeout(() => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 0);
}

// Add near your other fields
coinPerDayRowsByGame: {
  [gameName: string]: Array<{
    boardAssetTag: string;
    boardSerialNumber: string;
    locationName: string;
    salesRepName: string;
    coinInTotal: number;
    days: number;
    coinPerDay: number;
  }>
} = {};

avgCoinPerDayByGame: Record<string, number> = {};
boardsPerGame: Record<string, number> = {};   // ðŸ‘ˆ NEW
avgCoinPerDayLoading = false;



private closeAllTables() {
  this.showStats = false;
  this.showFortuneLiveStats = false;
  this.showFortuneLiveTestStats = false;
  this.showGameStats = false;
  this.showLocationPage = false;
  this.showWarehousePage = false;
  this.showBoardInventoryPage = false;
  this.showNewLocationPage = false;
  this.showSalesOutletPage = false;
  this.showTable = false;
  this.showLeadsPage = false;
  this.showLeadsTable = false;
  this.showTopGameStats = false; // âœ… make sure this is included
  this.showRptChart = false;
  this.activeGameTab = 'byGame';
  this.showTopGamesChart = false;
  this.showFusionLeaseStats = false;
  this.showPickupLocationStats = false;
  this.showBoardSalesStats = false;
}

// map of normalized -> set of original names returned by backend
private mergedNameMap = new Map<string, Set<string>>();
// trackBy helpers to reduce re-render churn
trackByGameKey = (_: number, key: string) => key;
trackByStat = (_: number, stat: any) => this.getSerial(stat) + '|' + this.getRowTs(stat);
trackByLead = (_: number, lead: any) => lead?.id || lead;
trackByTopGame = (_: number, game: any) => game?.gameName || game;
trackByBoardGroup = (_: number, group: any) => group?.summary?.boardAssetTag || group;
trackByRead = (_: number, read: any) => (read?.timeStamp || '') + (read?.boardAssetTag || '');
trackByLocation = (_: number, loc: any) => loc?.id || loc?.locationTag || loc;
trackByPayment = (_: number, p: any) => p?.id || p?.timeStamp || _;


    
    

  // Data
  board!: Board[];
  sortColumn: string = '';
  sortDirection: boolean = true;
  latestBoardStats = [];
  statsEndDate!: NgbDateStruct;
  statsStartDate!: NgbDateStruct;
  averageCashInPerDayPerFilteredBoard = 0;
  averageNetPerDayPerFilteredBoard = 0;
  fortuneLiveCashInPerDay = 0;
  fortuneLiveNetPerDay = 0;
  fortuneLiveRows = 0;
  fortuneLiveTestCashInPerDay = 0;
  fortuneLiveTestNetPerDay = 0;
  fortuneLiveTestRows = 0;
  daysSincePrevDisplay = 0;
  
  // Additional metrics
  contractedBoardsCount = 0;
  contractedBoardsWarehouseCount = 0;
  boardInventoryTotalBoards = 0;
  //totalAmountPaid: number = 0;
  totalMonthlyPayment: number = 0;
  totalNumBoards: number = 0;
  totalNewLocations: number = 0;
  totalNewBoards: number = 0;
  unseenPaymentsCount: number = 0;
  unseenStatsCount: number = 0;
  unseenLocationsCount: number = 0;


  
  
  // Form data
  formData!: UntypedFormGroup;
  chatSubmit!: boolean;
  
  // Arrays
  breadCrumbItems!: Array<{}>;
  salesReps!: SalesRep[];
  salesRepsToBeInvoiced: SalesRep[] = [];
  location: Location[] = [];
  invoices: Invoice[] = [];
  leads: LeadDTO[] = [];
  selectedLead: LeadDTO | null = null;

  constructor(
    private boardService: BoardService,
    private boardStatsService: BoardStatService,
    private modalService: NgbModal,
    private datePipe: DatePipe,
    private locationService: LocationService,
    private salesRepService: SalesRepService,
    public  loginService: LoginService,
    public invoiceService: InvoiceService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private toastr: ToastrService,
    private paymentService: PaymentService,
    private notificationService: NotificationService,
    private titleService: Title,
    private boardGameStatsService: BoardGameStatsService,
    private leadService: LeadService,
    private fusionConnectService: FusionConnectService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    (window as any).dashboardComponent = this;
    const today = new Date();
    this.statsEndDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };

    const oneMonthAgo = new Date(today);
    oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
    this.statsStartDate = {
      year: oneMonthAgo.getFullYear(),
      month: oneMonthAgo.getMonth() + 1,
      day: oneMonthAgo.getDate()
    };
    this.paymentForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.min(0)]],
      notes: ['']
    });
  }

  async ngOnInit(): Promise<void> {
    if (this.loginService.userType === UserType.INTERNAL) {
      void this.router.navigate(['/internal-dashboard']);
      return;
    }

    const requestedView = this.route.snapshot.queryParamMap.get('view');
    this.dashboardView = requestedView === 'fusionLease' || requestedView === 'boardSales'
      ? requestedView
      : 'fortune';
    this.currentUserType = this.loginService.userType;
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Dashboard', active: true }];
    this.formData = this.formBuilder.group({
      message: ['', [Validators.required]],
    });
    await this.initializeDashboard();

  }

  toggleOperationTable(table: 'stats' | 'contracts' | 'machines'): void {
    this.operationTable = this.operationTable === table ? null : table;
  }

  isExternalSalesRep(): boolean {
    return this.currentUserType === UserType.EXTERNAL || this.loginService.userType === UserType.EXTERNAL;
  }

  private resolveCurrentSalesRep(reps: SalesRep[] = this.allSalesReps): SalesRep | null {
    const user = this.loginService.user;
    if (!user || !(reps || []).length) {
      return null;
    }

    const normalizedUserId = this.normalizeId(this.loginService.userId);
    const username = (user.username || '').trim().toLowerCase();
    const email = (user.primaryEmail || '').trim().toLowerCase();
    const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim().toLowerCase();

    return reps.find((rep) =>
      this.normalizeId(rep.id) === normalizedUserId ||
      (rep.username || '').trim().toLowerCase() === username ||
      (rep.primaryEmail || '').trim().toLowerCase() === email ||
      `${rep.firstName || ''} ${rep.lastName || ''}`.trim().toLowerCase() === fullName
    ) || null;
  }

  private getActiveSalesRepIdentity(): { repId: string; repName: string } {
    const fallbackUser = this.loginService.user;
    const repId = this.normalizeId(this.currentSalesRep?.id || this.loginService.userId);
    const repName = `${this.currentSalesRep?.firstName || fallbackUser?.firstName || ''} ${this.currentSalesRep?.lastName || fallbackUser?.lastName || ''}`
      .trim()
      .toLowerCase();

    return { repId, repName };
  }

  private getActiveTopGameSalesRepId(): string | undefined {
    if (!this.isExternalSalesRep()) {
      return undefined;
    }

    return this.currentSalesRep?.id || this.loginService.userId || undefined;
  }

  private matchesActiveSalesRep(repIdValue: any, repNameValue: any): boolean {
    const { repId, repName } = this.getActiveSalesRepIdentity();
    const candidateRepId = this.normalizeId(repIdValue || '');
    const candidateRepName = (repNameValue || '').toString().trim().toLowerCase();

    if (repId && candidateRepId) {
      return candidateRepId === repId;
    }

    if (repName && candidateRepName) {
      return candidateRepName === repName;
    }

    return false;
  }
  

async refresh() {
  this.boardStatsCardLoading = true;
  const currentFreeMonths = { ...this.isFreeMonth };
  const currentCustomDays = { ...this.customDays };
  const previousStats = [...(this.boardStats || [])];
  const previousLocations = [...(this.location || [])];

  // bump the token for this refresh cycle; async Top Game requests must match this id
  const topGameLoadId = ++this.topGameLoadId;

  // clear any stale top-game state before new fetches to avoid flicker/flip-flop
  this.resetTopGameDerived();

  // Set access visibility
  if (this.loginService.userType === UserType.EXTERNAL) {
    this.showCardStats.cashInPerDay = true;
    this.showCardStats.detailedGameStats = true;
    this.showCardStats.gameStats = true;
    this.showCardStats.netPerDay = true;
    this.showCardStats.liveKonnectStats = true;
    this.showCardStats.topGame = true;
    this.showDashBoardCard.boardInventory = false;
    this.showDashBoardCard.lastWeeksInstallation = false;
    this.showDashBoardCard.totalMachieCount = true;
    this.showDashBoardCard.machineAvaiableDeploy = false;
    this.showDashBoardCard.monthlyRevenue = true;
    this.showDashBoardCard.salesOutlet = false;
    this.showDashBoardCard.lastWeekInstallation = false;
    this.showDashBoardCard.totalLeads = false;
    this.showStatsReport = false;
    this.showTopGameStats = false;
  } else if (this.loginService.userType === UserType.TECH) {
    this.showCardStats.cashInPerDay = false;
    this.showCardStats.detailedGameStats = false;
    this.showCardStats.gameStats = false;
    this.showCardStats.netPerDay = false;
    this.showCardStats.liveKonnectStats = false;
    this.showDashBoardCard.boardInventory = true;
    this.showDashBoardCard.lastWeeksInstallation = false;
    this.showDashBoardCard.totalMachieCount = true;
    this.showDashBoardCard.machineAvaiableDeploy = true;
    this.showDashBoardCard.monthlyRevenue = false;
    this.showDashBoardCard.lastWeekInstallation = true;
    this.showDashBoardCard.salesOutlet = false;
    this.showStatsReport = false;
    this.showTopGameStats = false;
  } else {
    this.showCardStats.cashInPerDay = true;
    this.showCardStats.detailedGameStats = true;
    this.showCardStats.gameStats = true;
    this.showCardStats.netPerDay = true;
    this.showCardStats.liveKonnectStats = true;
    this.showCardStats.topGame = true;
    this.showDashBoardCard.lastWeeksInstallation = true;
    this.showDashBoardCard.totalMachieCount = true;
    this.showDashBoardCard.machineAvaiableDeploy = true;
    this.showDashBoardCard.monthlyRevenue = true;
    this.showDashBoardCard.lastWeekInstallation = true;
    this.showDashBoardCard.boardInventory = true;
    this.showStatsReport = true;
    this.showTopGameStats = false;
  }

  try {
    const allLocations = await this.locationService.getAll();

    const startDate = this.statsStartDate
      ? new Date(this.statsStartDate.year, this.statsStartDate.month - 1, this.statsStartDate.day, 0, 0, 0)
      : new Date(new Date().getFullYear(), new Date().getMonth(), 1);

    const endDate = this.statsEndDate
      ? new Date(this.statsEndDate.year, this.statsEndDate.month - 1, this.statsEndDate.day, 23, 59, 59)
      : new Date();

    this.startDate = startDate;
    this.endDate = endDate;

    this.boardStatsLoaded = false;
    this.boardStats = [];
    this.filteredStats = [];
    this._allBoardStatsRaw = [];

    const [boardStatsSummary, categorySummaries] = await Promise.all([
      this.boardStatsService.getDashboardSummary(startDate, endDate),
      this.boardStatsService.getDashboardCategorySummaries(startDate, endDate)
    ]);
    if (boardStatsSummary) {
      this.averageCashInPerDayPerFilteredBoard = Number(boardStatsSummary.averageCashInPerDay || 0);
      this.averageNetPerDayPerFilteredBoard = Number(boardStatsSummary.averageNetPerDay || 0);
      this.daysSincePrevDisplay = Number(boardStatsSummary.daysSincePrevDisplay || 0);
      this.dashboardStatsCount = Number(boardStatsSummary.validStatsCount || 0);
      this.dashboardFlaggedStatsCount = Number(boardStatsSummary.flaggedStatsCount || 0);
    } else {
      this.averageCashInPerDayPerFilteredBoard = 0;
      this.averageNetPerDayPerFilteredBoard = 0;
      this.daysSincePrevDisplay = 0;
      this.dashboardStatsCount = 0;
      this.dashboardFlaggedStatsCount = 0;
    }

    const toCardSummary = (summary: any) => ({
      cashIn: Number(summary?.averageCashInPerDay || 0),
      net: Number(summary?.averageNetPerDay || 0),
      rows: Number(summary?.validStatsCount || 0) + Number(summary?.flaggedStatsCount || 0)
    });
    this.fusionLeaseSummary = toCardSummary(categorySummaries?.FUSION_LEASE);
    this.pickupSummary = toCardSummary(categorySummaries?.PICKUP);
    this.boardSalesSummary = toCardSummary(categorySummaries?.BOARD_SALES);

    let topGames = await this.boardGameStatsService.getTopGames(
      startDate.toISOString(),
      endDate.toISOString(),
      this.getActiveTopGameSalesRepId()
    );
    topGames = this.mergeTopGamesByName(topGames);

    let filteredStats: BoardStatsWithRaw[] = [];
    this.currentSalesRep = this.resolveCurrentSalesRep(this.allSalesReps.length ? this.allSalesReps : this.salesReps);

    if (this.loginService.userType === UserType.EXTERNAL) {
      filteredStats = [];

      topGames = topGames.filter((game: any) => this.matchesActiveSalesRep(game?.salesRepId, null));
      this.selectedSalesRep = this.currentSalesRep;
      this.liveSelectedSalesRep = this.currentSalesRep;
    } else {
      filteredStats = [];
    }

    // assign once only
    this.boardStats = filteredStats;

    this.pkgByAssetTag = {};
    const latestByTag: Record<string, { ts: number; pkg: string }> = {};

    for (const [tag, v] of Object.entries(latestByTag)) {
      this.pkgByAssetTag[tag] = v.pkg;
    }

    this.allTopGameStats = topGames;
    this.topGameStats = topGames;

    this.topGameStats = topGames;
    await this.computeFilteredTotalsForTopGames(topGameLoadId);

    this.boardStatsByGame = this.boardStatsService.groupStatsByBoardDetails(
      this.boardStats.filter(s => !this.isFlaggedStat(s)),
      this.boardStatsService.standardGameKeyFunction
    );

    await this.loadFortuneLiveMetrics(startDate, endDate);

    if (this.boardStatsLoaded && previousStats.length > 0) {
      const newStats = this.boardStats.filter(stat =>
        !previousStats.some(ps => ps.id === stat.id)
      );

      if (newStats.length > 0) {
        this.unseenStatsCount = newStats.length;
        this.notificationService.notifyNewStats(newStats);
        this.updateAppIconBadge();
      }
    }

    const visibleLocations = this.isExternalSalesRep() && this.currentSalesRep
      ? allLocations.filter((loc) => this.matchesActiveSalesRep(loc?.salesRep?.id, `${loc?.salesRep?.firstName || ''} ${loc?.salesRep?.lastName || ''}`))
      : allLocations;

    this.location = visibleLocations;
    this.lostInventoryLocation = this.findLostInventoryLocation(this.location);

    const allBoards = await this.boardService.getAll();
    this.board = allBoards || [];
    this.lostInventoryBoardCount = this.countLostInventoryBoards(allBoards);

    if (previousLocations.length > 0) {
      const newLocations = this.location.filter(loc =>
        !previousLocations.some(pl => pl.id === loc.id)
      );

      if (newLocations.length > 0) {
        newLocations.forEach(loc => {
          this.notificationService.notifyNewLocation(loc);
        });
      }
    }

    const fortuneLocations = visibleLocations.filter(loc => this.isFortuneRouteLocation(loc));

    if (this.isExternalSalesRep()) {
      this.contractedBoardsCount = fortuneLocations
        .reduce((sum, loc) => sum + Number(loc?.numBoards || 0), 0);
      this.contractedBoardsWarehouseCount = 0;
    } else {
      this.contractedBoardsCount = fortuneLocations
        .reduce((sum, loc) => sum + Number(loc?.numBoards || 0), 0);
      this.contractedBoardsWarehouseCount = await this.boardService.countContractedBoardsWarehouse();
    }

    this.filteredLocations = fortuneLocations;

    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    const lastWeekNewLocations = this.location.filter(loc => {
      const start = loc.locationStartDate ? new Date(loc.locationStartDate) : null;
      const validDate = !!start && !isNaN(start.getTime()) && start >= sevenDaysAgo;
      const enabled = loc.enabled === true;
      const hasBoards = (loc.numBoards || 0) > 0;
      const notWarehouse = !/\bwarehouse\b/i.test((loc.salesRep?.firstName || '').trim());
      const notSalesOutlet = !this.isSalesOutlet(loc);
      return enabled && hasBoards && validDate && notWarehouse && notSalesOutlet;
    });

    this.totalNewLocations = lastWeekNewLocations.length;
    this.totalNewBoards = lastWeekNewLocations.reduce((sum, l) => sum + (l.numBoards || 0), 0);

    this.filteredLocation = this.location.filter(this.warehouseFilter);
    this.contractedBoardsWarehouseCount = this.filteredLocation.reduce((sum, loc) => {
      const name = (loc.locationName || '').toLowerCase();
      const tag = (loc.locationTag || '').trim().toUpperCase();
      const isTestingWarehouse = tag === 'C27077' || name.includes('warehouse board testing');
      if (isTestingWarehouse) return sum;
      return sum + (loc.numBoards || 0);
    }, 0);

    this.filteredNewLocations = this.location.filter(this.showNewLocationFilter);
    this.boardInventoryLocations = this.location.filter(this.boardInventoryFilter);
    this.boardInventoryTotalBoards = this.boardInventoryLocations.reduce(
      (sum, loc) => sum + (loc.numBoards || 0),
      0
    );

    const inventoryBoards = await this.loadBoardInventoryBoards();
    this.updateBoardInventoryTypeCounts(inventoryBoards);

    console.log("All reps from backend:", this.salesReps);
    this.salesReps = await this.salesRepService.getAll();
    this.allSalesReps = [...this.salesReps];
    this.currentSalesRep = this.resolveCurrentSalesRep(this.allSalesReps);

    if (this.loginService.userType === UserType.EXTERNAL) {
      this.salesReps = this.currentSalesRep ? [this.currentSalesRep] : [];
      this.selectedSalesRep = this.currentSalesRep;
    } else {
      this.salesReps = this.salesReps.filter(
        salesRep => salesRep.tenDollarEnabled || salesRep.fiveDollarEnabled
      );
      console.log("After filter:", this.salesReps);
      this.salesReps.sort((a, b) => b.numBoards - a.numBoards);
    }

    const start = this.startDate.toISOString().split("T")[0];
    const end = this.endDate.toISOString().split("T")[0];
    const summaries = await this.paymentService.getPaymentSummaries(start, end);
    this.paymentSummaries = summaries;

    this.salesRepsToBeInvoiced = [];
    this.totalMonthlyPayment = 0;
    this.totalNumBoards = 0;

    for (const salesRep of this.salesReps) {
      const summary = summaries.find(s => s.salesRepId === salesRep.id);
      const backendFree = summary?.freeMonth ?? false;
      const currentFree = currentFreeMonths[salesRep.id];
      const isFree = currentFree !== undefined ? currentFree : backendFree;

      this.isFreeMonth[salesRep.id] = isFree;

      if (isFree) {
        salesRep.monthlyPayment = 0;
      } else {
        if (currentCustomDays[salesRep.id]) {
          this.customDays[salesRep.id] = currentCustomDays[salesRep.id];
        }
        salesRep.monthlyPayment = this.calculateTotal(salesRep);
      }

      if (!isFree) {
        this.totalMonthlyPayment += salesRep.monthlyPayment;
      }

      this.totalNumBoards += salesRep.numBoards;

      if (!this.invoiceService.hasBeenInvoiced(salesRep)) {
        this.salesRepsToBeInvoiced.push(salesRep);
      }
    }

    this.salesRepsToBeInvoiced = [];
    this.totalMonthlyPayment = 0;
    this.totalNumBoards = 0;

    this.salesReps.forEach(rep => {
      const summary = this.paymentSummaries.find(s => s.salesRepId === rep.id);

      const backendFree = summary?.freeMonth ?? false;
      const currentFree = currentFreeMonths[rep.id];
      const isFree = currentFree !== undefined ? currentFree : backendFree;

      this.isFreeMonth[rep.id] = isFree;

      if (isFree) {
        rep.monthlyPayment = 0;
      } else {
        if (currentCustomDays[rep.id]) {
          this.customDays[rep.id] = currentCustomDays[rep.id];
        }
        rep.monthlyPayment = this.calculateTotal(rep);
      }

      if (!isFree) {
        this.totalMonthlyPayment += rep.monthlyPayment || 0;
      }

      this.totalNumBoards += rep.numBoards || 0;

      if (!this.invoiceService.hasBeenInvoiced(rep)) {
        this.salesRepsToBeInvoiced.push(rep);
      }
    });

  } catch (error) {
    console.error('Dashboard refresh error:', error);
  }

  // Publish the main Board Stats card only from the exact same rows used by
  // its table. This avoids displaying a fast-but-different aggregate first.
  await this.ensureBoardStatsLoaded(true);
  this.applyAllFilters(this.term);
  this.calculateAverages();
  this.dashboardStatsCount = this.validStats.length;
  this.dashboardFlaggedStatsCount = this.flaggedStats.length;
  this.boardStatsCardLoading = false;
  this.rebuildStatesList();
  this.cdr.markForCheck();
}

  


  // Location management methods
  filterLocations() {
    if (!this.locationSearchTerm) {
      this.location.filter(loc => {
        console.log("Checking location:", loc); // Debugging line
    
        // Ensure 'enabled' is explicitly checked
        const isEnabled = loc.enabled === true;
        
        // Ensure numBoards is greater than zero
        const hasBoards = loc.numBoards > 0;
    
        // Ensure 'Warehouse' is not in the name (case insensitive)
        const isNotWarehouse = !/\bwarehouse\b/i.test(loc.salesRep?.firstName.trim());
    
        console.log(`Enabled: ${isEnabled}, Has Boards: ${hasBoards}, Is Not Warehouse: ${isNotWarehouse}`);
    
        return isEnabled && hasBoards && isNotWarehouse;
    });
      return;
    }

    const searchTerm = this.locationSearchTerm.toLowerCase();
    this.filteredLocations = this.location.filter(loc => 
      loc.locationTag?.toLowerCase().includes(searchTerm) ||
      loc.locationName?.toLowerCase().includes(searchTerm) ||
      loc.businessAddress.streetAddress1?.toLowerCase().includes(searchTerm) ||
      loc.businessAddress.city?.toLowerCase().includes(searchTerm) ||
      loc.businessAddress.state?.toLowerCase().includes(searchTerm) ||
      loc.businessAddress.zipCode?.toLowerCase().includes(searchTerm)
    );
  }
private async loadData() {
  this.isLoading = true;
  try {
    // 1. Load all sales reps
    const reps = await this.salesRepService.getAll();
    this.salesReps = reps || [];

    // 2. Initialize maps
    this.salesReps.forEach(rep => {
      this.paymentAmounts[rep.id] = 0;
      this.isFreeMonth[rep.id] = false;
      this.customDays[rep.id] = 0;
      this.currentMonthPayments[rep.id] = [];  // Prevents undefined errors
    });

    // 3. Load current month payments (safe)
    if (this.salesReps.length > 0) {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;

      for (const rep of this.salesReps) {
        try {
          const payments = await this.paymentService.getPaymentsByPeriod(rep.id, year, month);
          this.currentMonthPayments[rep.id] = payments;

          // Calculate total paid (excluding free months)
          this.totalPaid[rep.id] = payments
            .filter(p => !p.isFreeMonth)
            .reduce((total, p) => total + (p.amount || 0), 0);

          this.isFreeMonth[rep.id] = payments.some(p => p.isFreeMonth);
          console.log("âœ… All salesRep IDs returned from DB payments:", Object.keys(this.currentMonthPayments));

const missing = Object.keys(this.currentMonthPayments).filter(id => 
  !this.salesReps.find(rep => String(rep.id) === id)
);

console.warn("âŒ Sales reps in payments but missing in frontend salesReps:", missing);

        } catch (err) {
          console.warn(`Could not load payments for ${rep.firstName} (${rep.id})`, err);
          this.currentMonthPayments[rep.id] = []; // fallback
        }
      }
    }

    // âœ… 4. Load locations
    this.location = await this.locationService.getAll();
    this.lostInventoryLocation = this.findLostInventoryLocation(this.location);
    this.filteredNewLocations = this.location.filter(this.showNewLocationFilter);
    console.log("ðŸ“ Filtered new locations:", this.filteredNewLocations);

    // âœ… 5. Recalculate totals
    this.recalculateTotals();

    // âœ… 6. Update filteredSalesReps AFTER payments are loaded
    this.updateSalesRepsList();

  } catch (error) {
    console.error('Error loading data:', error);
    this.toastr.error('Failed to load data');
  } finally {
    this.isLoading = false;
    this.cdr.detectChanges();
  }
}

async initializeDashboard(): Promise<void> {
  this.isLoading = true;

  try {
    // 1. Load reps
    this.salesReps = await this.salesRepService.getAll();
    this.allSalesReps = [...this.salesReps];
    const invoiceEligibleReps = this.salesReps.filter(r => r.tenDollarEnabled || r.fiveDollarEnabled);

    // Restrict for sales rep login
    if (this.currentUserType === 'EXTERNAL') {
      this.currentSalesRep = this.resolveCurrentSalesRep(this.allSalesReps);
      this.salesReps = this.currentSalesRep ? [this.currentSalesRep] : [];
      this.selectedSalesRep = this.currentSalesRep;
      this.liveSelectedSalesRep = this.currentSalesRep;
    } else {
      this.salesReps = invoiceEligibleReps;
    }

    this.setMonthToDate();

    // Always initialize defaults so table is never empty
    this.salesReps.forEach(rep => {
      (rep as any).amountPaid = 0;
      this.paymentAmounts[rep.id] = 0;
      this.isFreeMonth[rep.id] = false;
      this.customDays[rep.id] = 0;
    });

    await this.loadCurrentMonthPayments();
    console.log('Payments Loaded:', this.currentMonthPayments);

    this.zone.run(() => this.cdr.detectChanges());

   // await this.loadSummaries();

    // 2. Load payment summaries
    try {
      const today = new Date();
      const start = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
      const end = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];

      let summaries;
      if (this.currentUserType === 'EXTERNAL' && this.loginService.userId) {
        summaries = await this.paymentService.getPaymentSummaryForUser(
          this.loginService.userId,
          start,
          end
        );
      } else {
        summaries = await this.paymentService.getPaymentSummaries(start, end);
      }

      this.totalPaid = {};

      summaries.forEach(summary => {
        const normalizedId = summary.salesRepId.replace(/-/g, '').toLowerCase();
        const amount = summary.totalAmount ?? 0;
        this.totalPaid[normalizedId] = amount;

        const match = this.salesReps.find(
          r => r.id.replace(/-/g, '').toLowerCase() === normalizedId
        );
        if (match) (match as any).amountPaid = amount;
      });

      console.log('Total Paid Map:', this.totalPaid);
      console.log('Summaries from API:', summaries);
    console.log('Sales reps before merge:', this.salesReps);

    } catch (e) {
      console.error('Error fetching payment summaries â†’ using defaults', e);
      this.totalPaid = {};
      // ðŸ‘‡ ensure table still renders with reps
      this.salesReps.forEach(rep => {
        if ((rep as any).amountPaid === undefined) (rep as any).amountPaid = 0;
      });
    }

    // 3. Load leads
    await this.loadTotalLeads();
    await this.loadLeads();

    await this.refresh();
    // These two performance cards need row-level data to calculate their
    // filtered Cash In/Day and Net/Day values before either card is clicked.
    this.recalculateTotals();
    this.updateSalesRepsList();
  } catch (error) {
    console.error('Dashboard init error:', error);
    this.toastr.error('Failed to load dashboard data');
  } finally {
    this.isLoading = false;
    this.cdr.markForCheck();
    
  }
}


  addNewLocation() {
    // Implement location creation logic
    console.log('Adding new location');
  }

  editLocation(location: Location) {
    // Implement location editing logic
    console.log('Editing location:', location);
  }

  deleteLocation(location: Location) {
    // Implement location deletion logic
    if (confirm(`Are you sure you want to delete ${location.locationName}?`)) {
      console.log('Deleting location:', location);
    }
  }

  // Filtering methods
  warehouseFilter = (location: Location) => {
    if (!location) return false;
    const name = (location.locationName || '').toLowerCase();
    const tag = (location.locationTag || '').trim().toUpperCase();
    const enabled = location.enabled === true;
    const hasBoards = (location.numBoards || 0) > 0;

    const isWarehouseName = name.includes('warehouse');
    const isGeorgiaInventory = tag === 'C27676' || name === 'georgia machine inventory without boards';

    if (!enabled) return false;

    // Always include the explicit Georgia inventory location, even if it currently has 0 boards
    if (isGeorgiaInventory) return true;

    return isWarehouseName && hasBoards;
  };
  boardInventoryFilter = (location: Location) => {
    const name = (location.locationName || '').toLowerCase();
    const enabled = location.enabled === true;
    const hasBoards = (location.numBoards || 0) > 0;
    const notSalesOutlet = !this.isSalesOutlet(location);
    return enabled && hasBoards && name.includes('board inventory') && notSalesOutlet;
  };
  private findLostInventoryLocation(locations: Location[]): Location | null {
    return (locations || []).find(loc => this.isLostInventory(loc)) || null;
  }
  private isLostInventory(loc?: Location | null): boolean {
    const name = (loc?.locationName || '').toLowerCase();
    return name.includes('lost inventory') || name.includes('lost machine inventory');
  }
  private countLostInventoryBoards(boards: Board[] = []): number {
    return (boards || []).filter(b => {
      const locName =
        b.location?.locationName ||
        b.currentDeployment?.location?.locationName ||
        '';
      return this.isLostInventory({ locationName: locName } as Location);
    }).length;
  }
  showNewLocationFilter = (location: Location) => {

  if (!location.locationStartDate) {
    return false;
  }

  const locationStartDate = new Date(location.locationStartDate);
  if (isNaN(locationStartDate.getTime())) {
    console.log('â›”ï¸ Invalid date:', location.locationStartDate);
    return false;
  }

  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

  const isValid = location.locationName?.toLowerCase() !== 'warehouse' &&
                  location.numBoards > 0 &&
                  locationStartDate >= sevenDaysAgo;

  console.log('âœ… Include?', isValid);

  return isValid;
};


  // Stats and filtering methods
  async onDateChange() {
    console.log('Date changed:', this.statsStartDate, this.statsEndDate);
    await this.refresh(); // uses selected date
    if (this.showStats || this.showFusionLeaseStats || this.showBoardSalesStats) {
      await this.ensureBoardStatsLoaded(true);
    } else {
      this.calculateAverages(); // updates UI
    }
  }
  
  
  get gameList(): string[] {
    return this.boardStatsByGame ? Array.from(this.boardStatsByGame.keys()) : [];
  }

onSearch() {
  if (this.activeFilterContext === 'live') {
    this.updateFortuneLiveSummary();
    this.cdr.detectChanges();
    return;
  }

  this.applyAllFilters(this.term);
}

private searchTimer: any;
  private boardSearchTimer: any;
onSearchDebounced(term: string) {
  if (this.activeFilterContext === 'live') {
    this.liveTerm = term;
  } else {
    this.term = term;
  }

  if (this.searchTimer) {
    clearTimeout(this.searchTimer);
  }
  this.searchTimer = setTimeout(() => this.onSearch(), 200);
}

  onBoardSearchDebounced(term: string) {
    if (this.activeFilterContext === 'live') {
      this.liveBoardSearchTerm = term;
    } else {
      this.boardSearchTerm = term;
    }

    if (this.boardSearchTimer) {
      clearTimeout(this.boardSearchTimer);
    }
    this.boardSearchTimer = setTimeout(() => this.onSearch(), 200);
  }

onSalesRepFilterChange() {
  if (this.activeFilterContext === 'live') {
    this.updateFortuneLiveSummary();
    this.cdr.detectChanges();
    return;
  }

  this.applyAllFilters();
}
  updateFilteredStats(filter: any = null) {
    if (filter) {
      this.filteredStats = this.boardStats.filter(boardStats => {
        const board = boardStats.board;
        if (!board) {
          return false;
        }

        const matchesFilter = 
          (this.datePipe.transform(boardStats.timeStamp)?.toLowerCase().includes(filter)) ||
          ((board.serialNumber ?? '').toLowerCase().includes(filter)) ||
          ((board.assetTag ?? '').toLowerCase().includes(filter)) ||
          ((board.location?.salesRep?.firstName ?? '').toLowerCase().includes(filter)) ||
          ((board.location?.salesRep?.lastName ?? '').toLowerCase().includes(filter)) ||
          ((board.location?.locationName ?? '').toLowerCase().includes(filter)) ||
          ((board.installedGamePackage?.name ?? '').toLowerCase().includes(filter)) ||
          ((board.installedGamePackage?.version ?? '').toLowerCase().includes(filter));

        const matchesSalesRep = !this.selectedSalesRep || 
          board.location?.salesRep?.id === this.selectedSalesRep.id;

        return matchesFilter && matchesSalesRep;
      });
    } else {
      this.filteredStats = this.selectedSalesRep ? 
        this.boardStats.filter(stat => 
          stat.board?.location?.salesRep?.id === this.selectedSalesRep.id
        ) : 
        this.boardStats;
    }

    this.boardStatsByGame = this.boardStatsService.groupStatsByBoardDetails(
      this.validStats,
      this.boardStatsService.standardGameKeyFunction
    );
    // The unfiltered card already has the authoritative backend aggregate.
    // Recalculate only when the user intentionally applies dashboard filters.
    if (this.hasActiveDashboardFilters()) {
      this.calculateAverages();
    }
    this.updateSalesRepsList();
    this.cdr.detectChanges();
  }

calculateAverages() {
  if (!this.boardStatsLoaded) {
    this.cdr.detectChanges();
    return;
  }

  this.averageCashInPerDayPerFilteredBoard = 0;
  this.averageNetPerDayPerFilteredBoard = 0;
  this.daysSincePrevDisplay = 0;

  const stats = this.validStats;

  if (stats.length > 0) {
    let totalCashInPerDay = 0;
    let totalNetPerDay = 0;
    let validStatsCount = 0;

    for (const stat of stats) {
      if (stat.daysSincePrevRead > 0) {
        const cashInPerDay = stat.cashInDiff / stat.daysSincePrevRead;
        const netPerDay = stat.profit / stat.daysSincePrevRead;

        if (!isNaN(cashInPerDay) && !isNaN(netPerDay)) {
          totalCashInPerDay += cashInPerDay;
          totalNetPerDay += netPerDay;
          validStatsCount++;
        }
      }
    }

    if (validStatsCount > 0) {
      this.averageCashInPerDayPerFilteredBoard = totalCashInPerDay / validStatsCount;
      this.averageNetPerDayPerFilteredBoard = totalNetPerDay / validStatsCount;
    }
  }

  this.updateDaysSincePrevDisplay();
  this.cdr.detectChanges();
}

private async loadFortuneLiveMetrics(startDate: Date, endDate: Date): Promise<void> {
  try {
    const from = this.formatLocalDateOnly(startDate);
    const to = this.formatLocalDateOnly(endDate);
    const result = await this.fusionConnectService.fetchDailyStats({ from, to, page: 0, pageSize: 2000 });

    let rows = (result?.content || []) as FusionConnectDailyStat[];
    rows = this.filterFortuneRowsForActiveSalesRep(rows);

    const validRows = rows.filter((item) => Number(item.cashIn || 0) > 0 || Number(item.net ?? (item.cashIn || 0) - (item.cashOut || 0)) !== 0);
    this.fortuneLiveStats = [...validRows].sort((a, b) => (b.statDate || '').localeCompare(a.statDate || ''));
    this.updateFortuneLiveSummary();
  } catch (err) {
    console.warn('[Dashboard] Fortune live metrics unavailable', err);
    this.fortuneLiveCashInPerDay = 0;
    this.fortuneLiveNetPerDay = 0;
    this.fortuneLiveRows = 0;
    this.fortuneLiveTestCashInPerDay = 0;
    this.fortuneLiveTestNetPerDay = 0;
    this.fortuneLiveTestRows = 0;
  }
}

private updateFortuneLiveSummary(): void {
  this.applyFortuneLiveSummary(this.filteredFortuneLiveStats || [], false);
  this.applyFortuneLiveSummary(this.filteredFortuneLiveTestStats || [], true);
}

private applyFortuneLiveSummary(rows: FusionConnectDailyStat[], testRows: boolean): void {
  if (testRows) {
    this.fortuneLiveTestRows = rows.length;
  } else {
    this.fortuneLiveRows = rows.length;
  }

  if (!rows.length) {
    if (testRows) {
      this.fortuneLiveTestCashInPerDay = 0;
      this.fortuneLiveTestNetPerDay = 0;
    } else {
      this.fortuneLiveCashInPerDay = 0;
      this.fortuneLiveNetPerDay = 0;
    }
    return;
  }

  const totalCashIn = rows.reduce((sum, item) => sum + Number(item.cashIn || 0), 0);
  const totalNet = rows.reduce((sum, item) => sum + Number(item.net ?? (Number(item.cashIn || 0) - Number(item.cashOut || 0))), 0);

  if (testRows) {
    this.fortuneLiveTestCashInPerDay = totalCashIn / rows.length;
    this.fortuneLiveTestNetPerDay = totalNet / rows.length;
  } else {
    this.fortuneLiveCashInPerDay = totalCashIn / rows.length;
    this.fortuneLiveNetPerDay = totalNet / rows.length;
  }
}

private hasActiveDashboardFilters(): boolean {
  return !!(
    (this.term || '').trim() ||
    (this.boardSearchTerm || '').trim() ||
    (this.selectedState || '').trim() ||
    (!this.isExternalSalesRep() && this.selectedSalesRep)
  );
}

private getActiveMetricSalesReps(): SalesRep[] {
  if (this.hasActiveDashboardFilters() && (this.filteredSalesRepsArray || []).length) {
    return this.filteredSalesRepsArray;
  }

  return this.salesReps || [];
}

private filterFortuneRowsForActiveSalesRep(rows: FusionConnectDailyStat[]): FusionConnectDailyStat[] {
  const activeRep = this.isExternalSalesRep() ? this.currentSalesRep : this.liveSelectedSalesRep;

  if (!this.isExternalSalesRep() && !activeRep) {
    return rows;
  }

  const { repId, repName } = this.getActiveSalesRepIdentity();

  return (rows || []).filter((item) => {
    const itemRepId = this.normalizeId(item.salesRepId || '');
    const itemRepName = (item.salesRepName || '').trim().toLowerCase();

    if (repId && itemRepId) {
      return itemRepId === repId;
    }

    if (repName && itemRepName) {
      return itemRepName === repName;
    }

    return !this.isExternalSalesRep();
  });
}

get filteredFortuneLiveStats(): FusionConnectDailyStat[] {
  return this.filterFortuneLiveRowsByDashboardFilters(false, false);
}

get filteredFortuneLiveTestStats(): FusionConnectDailyStat[] {
  return this.filterFortuneLiveRowsByDashboardFilters(true, false);
}

get flaggedFortuneLiveStats(): FusionConnectDailyStat[] {
  return this.filterFortuneLiveRowsByDashboardFilters(false, true);
}

get flaggedFortuneLiveTestStats(): FusionConnectDailyStat[] {
  return this.filterFortuneLiveRowsByDashboardFilters(true, true);
}

private filterFortuneLiveRowsByDashboardFilters(testRows: boolean, includeFlagged: boolean): FusionConnectDailyStat[] {
  const textFilter = (this.liveTerm || '').trim().toLowerCase();
  const boardFilter = (this.liveBoardSearchTerm || '').trim().toLowerCase();
  const activeRep = this.liveSelectedSalesRep;
  const selectedRepId = this.normalizeId(activeRep?.id || '');
  const selectedRepName = `${activeRep?.firstName || ''} ${activeRep?.lastName || ''}`.trim().toLowerCase();
  const selectedState = (this.liveSelectedState || '').trim().toLowerCase();

  return (this.fortuneLiveStats || []).filter((item) => {
    if (this.isFortuneWarehouseTestRow(item) !== testRows) {
      return false;
    }

    const flagged = this.isFlaggedFortuneLiveStat(item);
    if (includeFlagged ? !flagged : flagged) {
      return false;
    }

    const itemRepId = this.normalizeId(item.salesRepId || '');
    const itemRepName = (item.salesRepName || '').trim().toLowerCase();
    const itemState = this.getFortuneState(item).toLowerCase();
    const itemGameName = this.getFortuneGameName(item).toLowerCase();

    const fullText = [
      item.statDate,
      item.locationName,
      item.salesRepName,
      item.assetTag,
      item.serialNumber,
      itemGameName,
      itemState,
    ].map((value) => (value || '').toString().toLowerCase()).join(' ');

    const boardText = [item.assetTag, item.serialNumber]
      .map((value) => (value || '').toString().toLowerCase())
      .join(' ');

    const matchesText = !textFilter || fullText.includes(textFilter);
    const matchesBoard = !boardFilter || boardText.includes(boardFilter);
    const matchesRep = !activeRep || (!!selectedRepId ? itemRepId === selectedRepId : itemRepName === selectedRepName);
    const matchesState = !selectedState || itemState === selectedState;

    return matchesText && matchesBoard && matchesRep && matchesState;
  });
}

getFortuneLiveFlagNote(item: FusionConnectDailyStat): string {
  return (item?.flaggedNote || '').trim();
}

isFlaggedFortuneLiveStat(item: FusionConnectDailyStat): boolean {
  const value = item?.manuallyFlagged as any;
  return value === true || value === 1 || value === '1' || `${value}`.toLowerCase() === 'true';
}

async flagFortuneLiveStat(item: FusionConnectDailyStat): Promise<void> {
  const note = prompt('Enter reason for flagging this live row:');
  if (!note) {
    return;
  }

  if (!item?.id) {
    this.toastr.error('Missing live stat id');
    return;
  }

  try {
    await this.fusionConnectService.flagDailyStat({ id: item.id, flagged: true, note });
    this.toastr.warning('Live row flagged');
    await this.refresh();
  } catch (error) {
    console.error(error);
    this.toastr.error('Failed to flag live row');
  }
}

async unflagFortuneLiveStat(item: FusionConnectDailyStat): Promise<void> {
  if (!item?.id) {
    this.toastr.error('Missing live stat id');
    return;
  }

  try {
    await this.fusionConnectService.flagDailyStat({ id: item.id, flagged: false, note: '' });
    this.toastr.success('Live row unflagged');
    await this.refresh();
  } catch (error) {
    console.error(error);
    this.toastr.error('Failed to unflag live row');
  }
}

async deleteFortuneLiveRow(item: FusionConnectDailyStat): Promise<void> {
  if (!confirm('Delete this live row?')) {
    return;
  }

  if (!item?.id) {
    this.toastr.error('Missing live stat id');
    return;
  }

  try {
    await this.fusionConnectService.deleteDailyStat(item.id);
    this.toastr.info('Live row deleted');
    await this.refresh();
  } catch (error) {
    console.error(error);
    this.toastr.error('Failed to delete live row');
  }
}

private isFortuneWarehouseTestRow(item: FusionConnectDailyStat): boolean {
  const board = this.findFortuneBoard(item);
  const location = this.findFortuneLocation(item);
  const searchable = [
    item.locationName,
    item.salesRepName,
    location?.locationName,
    location?.locationTag,
    board?.location?.locationName,
    board?.location?.locationTag,
    board?.location?.salesRep?.firstName,
    board?.location?.salesRep?.lastName,
    board?.currentDeployment?.location?.locationName,
    board?.currentDeployment?.location?.locationTag,
  ].map(value => (value || '').toString().toLowerCase()).join(' ');

  return /\bwarehouse\b/.test(searchable) ||
    searchable.includes('test area') ||
    searchable.includes('board testing') ||
    searchable.includes('show room') ||
    searchable.includes('showroom');
}

get hasRegularStatsCard(): boolean {
  return !!this.showCardStats.cashInPerDay;
}

get hasTopGameCard(): boolean {
  return !!this.showCardStats.topGame && !!this.topGamePerDay && (this.topGameStats?.length || 0) > 0;
}

get hasGameStatsCard(): boolean {
  return !!this.showCardStats.gameStats && this.filteredGameCount > 0;
}

get filteredGameCount(): number {
  return Array.isArray(this.gameList) ? this.gameList.length : 0;
}

get filteredRegularBoardCount(): number {
  return Array.isArray(this.validStats) ? this.validStats.length : 0;
}

get fusionLeaseStats(): BoardStatsWithRaw[] {
  return (this.filteredStats || []).filter(
    stat => this.isFusionLeaseStat(stat) ||
      this.isMovedTo(stat, this.moveToFusionLeaseNote)
  );
}

get pickupLocationStats(): BoardStatsWithRaw[] {
  return (this.filteredStats || []).filter(
    stat => this.isPickupLocationStat(stat) ||
      this.hasStatsCategory(stat, 'PICKUP') ||
      this.isMovedTo(stat, this.moveToPickupNote)
  );
}

get pickupContractLocations(): Location[] {
  const allowed = new Set(this.pickupLocations.map(name => this.normalizeScopedName(name)));
  const movedLocationIds = new Set<string>();
  const movedLocationNames = new Set<string>();

  for (const stat of this.filteredStats || []) {
    if (!this.hasStatsCategory(stat, 'PICKUP') &&
        !this.isMovedTo(stat, this.moveToPickupNote)) continue;

    const statLocation =
      stat.board?.currentDeployment?.location ||
      stat.board?.location;
    const locationId = (statLocation?.id || '').toString();
    const locationName =
      stat.__locationName ||
      statLocation?.locationName;

    if (locationId) movedLocationIds.add(locationId);
    if (locationName) {
      movedLocationNames.add(this.normalizeScopedName(locationName));
    }
  }

  return (this.location || []).filter(loc => {
    const repName = `${loc.salesRep?.firstName || ''} ${loc.salesRep?.lastName || ''}`;
    const isConfiguredPickupRoute = allowed.has(this.normalizeScopedName(repName));
    const hasMovedPickupStat =
      movedLocationIds.has((loc.id || '').toString()) ||
      movedLocationNames.has(this.normalizeScopedName(loc.locationName));

    return (isConfiguredPickupRoute || hasMovedPickupStat) &&
      Number(loc.numBoards || 0) > 0;
  });
}

get boardSalesStats(): BoardStatsWithRaw[] {
  return (this.filteredStats || []).filter(stat => this.isBoardSalesStat(stat));
}

get boardSalesValidStats(): BoardStatsWithRaw[] {
  return this.boardSalesStats.filter(stat => !this.isFlaggedStat(stat));
}

get boardSalesFlaggedStats(): BoardStatsWithRaw[] {
  return this.boardSalesStats.filter(stat => this.isFlaggedStat(stat));
}

get boardSalesDailyMetrics(): { cashIn: number; net: number } {
  return this.getDailyMetrics(this.boardSalesValidStats);
}

get leaseContractLocations(): Location[] {
  const allowed = new Set(this.fusionLeaseSalesReps.map(name => this.normalizeScopedName(name)));
  return (this.location || []).filter(loc => {
    const repName = `${loc.salesRep?.firstName || ''} ${loc.salesRep?.lastName || ''}`;
    return allowed.has(this.normalizeScopedName(repName)) && this.isEnabledLocation(loc);
  });
}

get leaseContractCount(): number {
  return this.leaseContractLocations.length;
}

get leaseMachineCount(): number {
  return this.leaseContractLocations.reduce((total, loc) => total + Number(loc.numBoards || 0), 0);
}

get boardSalesContractLocations(): Location[] {
  return (this.location || []).filter(loc => {
    const repName = `${loc.salesRep?.firstName || ''} ${loc.salesRep?.lastName || ''}`;
    return this.isEnabledLocation(loc) &&
      (this.isSalesOutlet(loc) || this.normalizeScopedName(repName) === 'rahim visram');
  });
}

get boardSalesContractCount(): number {
  return this.boardSalesContractLocations.length;
}

get boardSalesMachineCount(): number {
  return this.boardSalesContractLocations.reduce((total, loc) => total + Number(loc.numBoards || 0), 0);
}

get activeOperationLocations(): Location[] {
  return this.dashboardView === 'fusionLease'
    ? this.leaseContractLocations
    : this.boardSalesContractLocations;
}

private isEnabledLocation(loc: Location): boolean {
  const enabled = (loc as any)?.enabled;
  return enabled === true || enabled === 1 || enabled === '1' || enabled === 'true';
}

get fusionLeaseValidStats(): BoardStatsWithRaw[] {
  return this.fusionLeaseStats.filter(
    stat => !this.isFlaggedStat(stat) || this.isMovedTo(stat, this.moveToFusionLeaseNote)
  );
}

get fusionLeaseFlaggedStats(): BoardStatsWithRaw[] {
  return this.fusionLeaseStats.filter(
    stat => this.isFlaggedStat(stat) && !this.isLegacyMoveMarker(stat)
  );
}

get pickupLocationValidStats(): BoardStatsWithRaw[] {
  return this.pickupLocationStats.filter(
    stat => !this.isFlaggedStat(stat) || this.isMovedTo(stat, this.moveToPickupNote)
  );
}

get pickupLocationFlaggedStats(): BoardStatsWithRaw[] {
  return this.pickupLocationStats.filter(
    stat => this.isFlaggedStat(stat) && !this.isLegacyMoveMarker(stat)
  );
}

get fusionLeaseDailyMetrics(): { cashIn: number; net: number } {
  return this.getDailyMetrics(this.fusionLeaseValidStats);
}

get pickupLocationDailyMetrics(): { cashIn: number; net: number } {
  return this.getDailyMetrics(this.pickupLocationValidStats);
}

private getNamedStats(
  type: 'salesRep' | 'location',
  allowedNames: readonly string[]
): BoardStatsWithRaw[] {
  const allowed = new Set(allowedNames.map(name => this.normalizeScopedName(name)));

  return (this.filteredStats || []).filter(stat => {
    const value = type === 'salesRep'
      ? (stat.__salesRepName ||
        `${stat.board?.currentDeployment?.location?.salesRep?.firstName || ''} ${stat.board?.currentDeployment?.location?.salesRep?.lastName || ''}`)
      : (stat.__locationName ||
        stat.board?.currentDeployment?.location?.locationName ||
        stat.board?.location?.locationName);

    return allowed.has(this.normalizeScopedName(value));
  });
}

private normalizeScopedName(value: any): string {
  return (value || '').toString().trim().replace(/\s+/g, ' ').toLowerCase();
}

private isFusionLeaseStat(stat: BoardStatsWithRaw): boolean {
  if (stat.statsCategory === 'STANDARD' ||
      stat.statsCategory === 'PICKUP' ||
      stat.statsCategory === 'BOARD_SALES') return false;
  if (stat.statsCategory === 'FUSION_LEASE') return true;
  const location = stat.board?.currentDeployment?.location || stat.board?.location;
  if (this.isSalesOutlet(location as Location)) return false;
  const repName = stat.__salesRepName ||
    `${stat.board?.currentDeployment?.location?.salesRep?.firstName || ''} ${stat.board?.currentDeployment?.location?.salesRep?.lastName || ''}`;
  const normalizedRep = this.normalizeScopedName(repName);

  return this.fusionLeaseSalesReps.some(
    name => this.normalizeScopedName(name) === normalizedRep
  );
}

private isPickupLocationStat(stat: BoardStatsWithRaw): boolean {
  if (stat.statsCategory === 'STANDARD' ||
      stat.statsCategory === 'FUSION_LEASE' ||
      stat.statsCategory === 'BOARD_SALES') return false;
  if (stat.statsCategory === 'PICKUP') return true;
  const salesLocation = stat.board?.currentDeployment?.location || stat.board?.location;
  if (this.isSalesOutlet(salesLocation as Location)) return false;
  const locationName = stat.__locationName ||
    stat.board?.currentDeployment?.location?.locationName ||
    stat.board?.location?.locationName;
  const repName = stat.__salesRepName ||
    `${stat.board?.currentDeployment?.location?.salesRep?.firstName || ''} ${stat.board?.currentDeployment?.location?.salesRep?.lastName || ''}`;
  const normalizedLocation = this.normalizeScopedName(locationName);
  const normalizedRep = this.normalizeScopedName(repName);

  return this.pickupLocations.some(
    name => {
      const normalizedName = this.normalizeScopedName(name);
      return normalizedName === normalizedLocation || normalizedName === normalizedRep;
    }
  );
}

private isDedicatedCardStat(stat: BoardStatsWithRaw): boolean {
  return this.isFusionLeaseStat(stat) ||
    this.isPickupLocationStat(stat) ||
    this.isBoardSalesStat(stat) ||
    this.isMoveCategoryStat(stat);
}

private isBoardSalesStat(stat: BoardStatsWithRaw): boolean {
  if (stat.statsCategory === 'STANDARD' ||
      stat.statsCategory === 'FUSION_LEASE' ||
      stat.statsCategory === 'PICKUP') return false;
  if (stat.statsCategory === 'BOARD_SALES') return true;

  const location = stat.board?.currentDeployment?.location || stat.board?.location;
  const repName = stat.__salesRepName ||
    `${location?.salesRep?.firstName || ''} ${location?.salesRep?.lastName || ''}`;
  if (this.normalizeScopedName(repName) === 'rahim visram') return true;
  return this.isSalesOutlet(location as Location);
}

private isMovedTo(stat: BoardStats | null | undefined, destination: string): boolean {
  return (stat?.flaggedNote || '').trim() === destination;
}

private isMoveCategoryStat(stat: BoardStats | null | undefined): boolean {
  return this.hasStatsCategory(stat, 'FUSION_LEASE') ||
    this.hasStatsCategory(stat, 'PICKUP') ||
    stat?.statsCategory === 'BOARD_SALES' ||
    this.isLegacyMoveMarker(stat);
}

private isLegacyMoveMarker(stat: BoardStats | null | undefined): boolean {
  return this.isMovedTo(stat, this.moveToFusionLeaseNote) ||
    this.isMovedTo(stat, this.moveToPickupNote);
}

private hasStatsCategory(
  stat: BoardStats | null | undefined,
  category: 'FUSION_LEASE' | 'PICKUP'
): boolean {
  return stat?.statsCategory === category;
}

private getDailyMetrics(stats: BoardStatsWithRaw[]): { cashIn: number; net: number } {
  let cashIn = 0;
  let net = 0;
  let count = 0;

  for (const stat of stats) {
    const days = Number(stat.daysSincePrevRead);
    if (days <= 0) continue;

    const cashInPerDay = Number(stat.cashInDiff) / days;
    const netPerDay = Number(stat.profit) / days;
    if (!Number.isFinite(cashInPerDay) || !Number.isFinite(netPerDay)) continue;

    cashIn += cashInPerDay;
    net += netPerDay;
    count++;
  }

  return {
    cashIn: count ? cashIn / count : 0,
    net: count ? net / count : 0
  };
}

setActiveFilterContext(context: 'regular' | 'live'): void {
  this.activeFilterContext = context;

  if (this.isExternalSalesRep() && this.currentSalesRep) {
    if (context === 'live') {
      this.liveSelectedSalesRep = this.currentSalesRep;
    } else {
      this.selectedSalesRep = this.currentSalesRep;
    }
  }
}

get activeSearchTerm(): string {
  return this.activeFilterContext === 'live' ? this.liveTerm : this.term;
}

set activeSearchTerm(value: string) {
  if (this.activeFilterContext === 'live') {
    this.liveTerm = value;
  } else {
    this.term = value;
  }
}

get activeBoardSearchTerm(): string {
  return this.activeFilterContext === 'live' ? this.liveBoardSearchTerm : this.boardSearchTerm;
}

set activeBoardSearchTerm(value: string) {
  if (this.activeFilterContext === 'live') {
    this.liveBoardSearchTerm = value;
  } else {
    this.boardSearchTerm = value;
  }
}

get activeSelectedSalesRep(): SalesRep | null {
  return this.activeFilterContext === 'live' ? this.liveSelectedSalesRep : this.selectedSalesRep;
}

set activeSelectedSalesRep(value: SalesRep | null) {
  if (this.activeFilterContext === 'live') {
    this.liveSelectedSalesRep = value;
  } else {
    this.selectedSalesRep = value;
  }
}

get activeSelectedState(): string | null {
  return this.activeFilterContext === 'live' ? this.liveSelectedState : this.selectedState;
}

set activeSelectedState(value: string | null) {
  if (this.activeFilterContext === 'live') {
    this.liveSelectedState = value;
  } else {
    this.selectedState = value;
  }
}

get hasFortuneLiveStatsCard(): boolean {
  return !!this.showCardStats.liveKonnectStats;
}

get hasFortuneLiveTestStatsCard(): boolean {
  return !!this.showCardStats.liveKonnectStats && this.filteredFortuneLiveTestStats.length > 0;
}

private findFortuneBoard(item: FusionConnectDailyStat): Board | undefined {
  const boardId = this.normalizeId(item.boardId || '');
  const assetTag = (item.assetTag || '').trim().toLowerCase();
  const serial = (item.serialNumber || '').trim().toLowerCase();

  return (this.board || []).find((b) => {
    const candidateId = this.normalizeId(b?.id || '');
    const candidateAsset = (b?.assetTag || '').trim().toLowerCase();
    const candidateSerial = (b?.serialNumber || '').trim().toLowerCase();

    return (!!boardId && candidateId === boardId)
      || (!!assetTag && candidateAsset === assetTag)
      || (!!serial && candidateSerial === serial);
  });
}

private findFortuneLocation(item: FusionConnectDailyStat): Location | undefined {
  const locationId = this.normalizeId(item.locationId || '');
  const locationName = (item.locationName || '').trim().toLowerCase();

  return (this.location || []).find((loc) => {
    const candidateId = this.normalizeId(loc?.id || '');
    const candidateName = (loc?.locationName || '').trim().toLowerCase();

    return (!!locationId && candidateId === locationId)
      || (!!locationName && candidateName === locationName);
  });
}

getFortuneState(item: FusionConnectDailyStat): string {
  const board = this.findFortuneBoard(item);
  const location = this.findFortuneLocation(item);
  const stateCandidates = [
    board?.location?.businessAddress?.state,
    board?.currentDeployment?.location?.businessAddress?.state,
    location?.businessAddress?.state,
    (item as any)?.state,
  ];

  return this.pickFirstString(stateCandidates) || '—';
}

getFortuneGameName(item: FusionConnectDailyStat): string {
  const board = this.findFortuneBoard(item);
  const gameCandidates = [
    board?.currentDeployment?.installedGamePackage?.name,
    board?.installedGamePackage?.name,
    this.pkgByAssetTag?.[(item.assetTag || '').trim()],
    (item as any)?.gameName,
  ];

  return this.pickFirstString(gameCandidates) || '—';
}

getFortunePayout(item: FusionConnectDailyStat): number {
  const cashIn = Number(item.cashIn || 0);
  const cashOut = Number(item.cashOut || 0);
  return cashIn > 0 ? (cashOut / cashIn) * 100 : 0;
}

getFortuneRpt(item: FusionConnectDailyStat): number {
  const coinIn = Number(item.coinIn || 0);
  const coinOut = Number(item.coinOut || 0);
  return coinIn > 0 ? (coinOut / coinIn) * 100 : 0;
}

getFortuneBetMultiplier(item: FusionConnectDailyStat): number {
  const cashIn = Number(item.cashIn || 0);
  const coinIn = Number(item.coinIn || 0);
  return cashIn > 0 ? coinIn / cashIn : 0;
}

getFortuneBetPerPlay(item: FusionConnectDailyStat): number {
  const gamesPlayed = Number(item.gamesPlayed || 0);
  const coinIn = Number(item.coinIn || 0);
  return gamesPlayed > 0 ? coinIn / gamesPlayed : 0;
}

private updateDaysSincePrevDisplay(): void {
  const stats = this.validStats.filter(s => Number(s?.daysSincePrevRead) > 0);

  if (!stats.length) {
    this.daysSincePrevDisplay = 0;
    return;
  }

  const sum = stats.reduce((acc, s) => acc + Number(s.daysSincePrevRead || 0), 0);

  const boardKeys = new Set(
    stats
      .map(s =>
        (
          s.board?.serialNumber ||
          (s as any)?.serialNumber ||
          s.board?.assetTag ||
          (s as any)?.assetTag ||
          ''
        )
          .toString()
          .toLowerCase()
      )
      .filter(Boolean)
  );

  this.daysSincePrevDisplay = boardKeys.size === 1 ? sum : sum / stats.length;
}
updateSalesRepsList() {
  const map = new Map<string, SalesRep>();

  // 1. Add reps from board stats
  for (const stat of this.filteredStats || []) {
    const repId = stat.__salesRepId;
    const srFromList = repId ? this.salesReps.find(r => r.id === repId) : undefined;
    const sr = srFromList || stat?.board?.location?.salesRep;
    if (sr?.id) map.set(sr.id, sr);
  }

  // 2. Add reps with payments (in case they aren't in board stats)
  for (const repId in this.currentMonthPayments) {
    const payments = this.currentMonthPayments[repId];
    if (payments.length > 0 && !map.has(repId)) {
      const matchingRep = this.salesReps.find(rep => rep.id === repId);
      if (matchingRep) {
        map.set(repId, matchingRep);
      }
    }
  }

  this.filteredSalesReps = map;
  this.filteredSalesRepsArray = this.isExternalSalesRep() && this.currentSalesRep
    ? [this.currentSalesRep]
    : Array.from(map.values());
}



  // Sorting and value retrieval
  getValueByColumn(item: any, column: string) {
    switch (column) {
      case 'timeStamp': return new Date(item.timeStamp).toISOString();
      case 'salesRep': return item.__salesRepName;
      case 'gameName': return item.board?.installedGamePackage?.name;
      case 'cashIn': return item.cashInDiff;
      case 'cashOut': return item.cashOutDiff;
      case 'coinIn': return item.coinInDiff;
      case 'coinOut': return item.coinOutDiff;
      case 'gamesPlayed': return item.gamePlayedDiff;
      case 'gamesWon': return item.gameWonDiff;
      case 'assetTag': return item.assetTag;
      case 'cashIn/day': return item.cashInDiff / item.daysSincePrevRead;
      case 'netRevenue': return item.cashInDiff - item.cashOutDiff;
      case 'netRevenue/day': return item.profit / item.daysSincePrevRead;
      case 'serialNumber': return item.serialNumber;
      case 'payoutPercentage': return item.holdPercentage;
      case 'rtp': return item.coinOutDiff / item.coinInDiff;
      case 'daysSincePrevRead': return item.daysSincePrevRead;
      default: return item[column];
    }
  }

sortData(column: string) {
  if (this.sortColumn === column) {
    this.sortDirection = !this.sortDirection;
  } else {
    this.sortColumn = column;
    this.sortDirection = true;
  }

  const list = this.filteredStats ?? [];
  list.sort((a, b) => {
    const valA = this.getValueByColumn(a, column);
    const valB = this.getValueByColumn(b, column);
    if (valA < valB) return this.sortDirection ? -1 : 1;
    if (valA > valB) return this.sortDirection ? 1 : -1;
    return 0;
  });
  this.cdr.markForCheck();
}


  // Modal and form methods
  openBoardStatsModal(assetTag: string): void {
    const modalRef = this.modalService.open(BoardStatsByIdComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.assetTag = assetTag;
  }

  openBoardStatsReport(): void {
    const modalRef = this.modalService.open(BoardStatsReportComponent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }
private calculateTotal(salesRep: SalesRep): number {
  const isFree = this.isFreeMonth[salesRep.id] || false;
  const customDays = this.customDays[salesRep.id] || this.daysInMonth;
  const boardCount = salesRep.numBoards || 0;

  return this.calculateMonthlyPayment(
    salesRep.id,
    boardCount,
    salesRep.tenDollarEnabled,
    salesRep.fiveDollarEnabled,
    isFree,
    customDays
  );
}

  

  generateInvoiceForSalesRep(salesRep: SalesRep): void {
    const invoice = this.invoiceService.generateInvoice(salesRep);
    this.refresh();
    console.log('Invoice PDF generated:', invoice);
  }

  sendReminderInvoicePDF(invoiceId: string): void {
    const userConfirmed = window.confirm('Do you want to send a reminder for this invoice?');
    if (userConfirmed) {
      this.invoiceService.sendExistingInvoiceEmail(invoiceId)
        .then((response: Invoice) => {
          console.log('Reminder sent successfully:', response);
        })
        .catch((error) => {
          console.error('Error sending reminder:', error);
        });
    }
  }

  // Toggle methods
  toggleWarehousePage() {
    this.showWarehousePage = !this.showWarehousePage;
  }

  toggleNewLocationPage() {
    this.showNewLocationPage = !this.showNewLocationPage;
  }

  toggleCardVisibility(): void {
    this.showCard = !this.showCard;
  }

  // Form getters
  get form() {
    return this.formData.controls;
  }

  getFormattedAmount(amount: number): string {
    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  async showLocationBoardStats(location: Location, modalContent: any) {
    if (!location) {
      console.error('No location provided');
      return;
    }

    this.selectedLocation = location;
    this.isLoadingLocationStats = true;
    this.locationBoardStats = [];
    
    try {
      // Get all boards for this location
      const boards = await this.locationService.getBoardsByLocationId(location.id);
      
      // Get the latest stats for each board
      const statsPromises = boards.map(board => 
        this.boardStatsService.getLatestByBoardId(board.id)
      );
      
      const stats = await Promise.all(statsPromises);
      this.locationBoardStats = stats.filter((stat): stat is BoardStats => stat !== null && this.hasNonZeroValues(stat));
      
      // Open the modal
      this.modalService.open(modalContent, {
        size: 'xl',
        scrollable: true
      });
    } catch (error) {
      console.error('Error fetching board stats:', error);
    } finally {
      this.isLoadingLocationStats = false;
    }
  }

  private hasNonZeroValues(stat: BoardStats): boolean {
    return stat.cashInDiff > 0 || 
           stat.cashOutDiff > 0 || 
           stat.coinInDiff > 0 || 
           stat.coinOutDiff > 0 || 
           stat.gamePlayedDiff > 0 || 
           stat.gameWonDiff > 0;
  }
  
async recordPayment(salesRep: SalesRep) {
  if (!salesRep?.id) {
    this.toastr.error('Invalid sales rep');
    return;
  }

  const isFree = this.isFreeMonth[salesRep.id] || false;
  const amount = isFree ? 0 : (this.paymentAmounts[salesRep.id] || 0);

  if (!isFree && amount <= 0) {
    this.toastr.error('Please enter a valid payment amount');
    return;
  }

  try {
    const notes = this.customDays[salesRep.id] > 0 
      ? `Payment for ${this.customDays[salesRep.id]} days`
      : this.paymentForm.get('notes')?.value || '';

    const payment = await this.paymentService.recordPayment(
      salesRep.id,
      amount,
      notes,
      isFree
    );

    this.notificationService.notifyNewPayment(payment);

    this.paymentAmounts[salesRep.id] = 0;
    this.customDays[salesRep.id] = 0;
    this.paymentForm.reset();

    this.toastr.success(isFree ? 'Free month recorded' : 'Payment recorded');

    await this.loadData();  // ensures currentMonthPayments + salesReps are accurate
    this.recalculateTotals();  // make sure the totals are accurate
  } catch (err) {
    console.error('Error recording payment:', err);
    this.toastr.error('Failed to record payment');
  }
}


  updateAppIconBadge() {
    const totalUnseen =
      this.unseenPaymentsCount +
      this.unseenStatsCount +
      this.unseenLocationsCount;
  
    if ('setAppBadge' in navigator && totalUnseen > 0) {
      (navigator as any).setAppBadge(totalUnseen).catch(console.warn);
    } else if ('clearAppBadge' in navigator) {
      (navigator as any).clearAppBadge().catch(console.warn);
    }
  
    this.updateTabTitle();
  }
  
  

      markPaymentsAsSeen() {
        this.unseenPaymentsCount = 0;
        this.updateTabTitle();
      
        if ('clearAppBadge' in navigator) {
          (navigator as any).clearAppBadge()
            .catch((err: any) => console.warn('Badge clear error', err));
        }
      }

      markStatsAsSeen() {
        this.unseenStatsCount = 0;
        this.updateTabTitle();
      
        if ('clearAppBadge' in navigator) {
          (navigator as any).clearAppBadge()
            .catch((err: any) => console.warn('Badge clear error', err));
        }
      }

      updateTabTitle() {
        const totalUnseen =
          this.unseenPaymentsCount +
          this.unseenStatsCount +
          this.unseenLocationsCount;
      
        const baseTitle = 'Fortune Group Games Dashboard';
      
        if (totalUnseen > 0) {
          this.titleService.setTitle(`(${totalUnseen}) ${baseTitle}`);
        } else {
          this.titleService.setTitle(baseTitle);
        }
      }
      
      
  
  
  
  async showPaymentHistory(salesRep: SalesRep) {
    this.selectedSalesRep = salesRep;
    try {
      this.paymentHistory = await this.paymentService.getPaymentHistory(salesRep.id);
      this.modalService.open(this.paymentHistoryModal, {
        size: 'lg',
        scrollable: true
      });
    } catch (error) {
      console.error('Error fetching payment history:', error);
      this.toastr.error('Failed to fetch payment history');
    }
  }
  
  private async loadCurrentMonthPayments() {
    const now = new Date();
    for (const salesRep of this.salesReps) {
      try {
        // Get payments for current period
        const payments = await this.paymentService.getPaymentsByPeriod(
          salesRep.id,
          now.getFullYear(),
          now.getMonth() + 1
        );
        
        this.currentMonthPayments[salesRep.id] = payments;
  
        // Check for free month payment and update UI state
        const freeMonthPayment = payments.find(p => p.isFreeMonth === true);
        if (freeMonthPayment) {
          this.isFreeMonth[salesRep.id] = true;
          salesRep.monthlyPayment = 0;
        } else {
          this.isFreeMonth[salesRep.id] = false;
          // Check for custom days payment
          const customDaysPayment = payments.find(p => p.notes?.includes('Payment for'));
          if (customDaysPayment) {
            const daysMatch = customDaysPayment.notes?.match(/Payment for (\d+) days/);
            if (daysMatch) {
              const days = parseInt(daysMatch[1]);
              this.customDays[salesRep.id] = days;
              salesRep.monthlyPayment = this.calculateTotal(salesRep);
            }
          } else {
            // If no custom days, calculate normal monthly payment
            salesRep.monthlyPayment = this.calculateTotal(salesRep);
          }
        }
  
        this.cdr.detectChanges();
      } catch (error) {
        console.error('Error loading payments for sales rep:', error);
        this.currentMonthPayments[salesRep.id] = [];
      }
    }
  
    this.calculateTotals();
    this.cdr.markForCheck();
  }
getTotalPaidAmount(salesRep: SalesRep): number {
  if (!this.currentMonthPayments || salesRep?.id == null) return 0;

  const repId = String(salesRep.id);
  const payments = this.currentMonthPayments[repId] ?? [];

  const total = payments
    .filter(p => !p.isFreeMonth && ['PAID', 'PARTIAL'].includes(p.status))  // âœ… fix here
    .reduce((sum, payment) => sum + (payment.amount || 0), 0);

  return total;
}




  
  getPaymentStatus(salesRep: SalesRep): string {
    const payments = this.currentMonthPayments[salesRep.id] || [];
    if (payments.length === 0) return 'PENDING';
    
    const hasFreeMonth = payments.some(p => p.isFreeMonth === true);
    if (hasFreeMonth) return 'PAID';
    
    const totalPaid = this.getTotalPaidAmount(salesRep);
    const monthlyPayment = salesRep.monthlyPayment || 0;
    
    if (totalPaid >= monthlyPayment) return 'PAID';
    if (totalPaid > 0) return 'PARTIAL';
    return 'PENDING';
  }

  getTotalCount(): number {
    let total = 0;
    this.gameList.forEach(gameKey => {
      total += this.boardStatsByGame.get(gameKey)?.count || 0;
    });
    return total;
  }
  
  getTotalValue(property: string): number {
    let total = 0;
    this.gameList.forEach(gameKey => {
      const value = this.boardStatsByGame.get(gameKey)?.[property as keyof GroupedStats];
      if (typeof value === 'number') {
        total += value;
      }
    });
    return total;
  }
  
  getAverageValue(property: string): number {
    let total = 0;
    let count = 0;
    this.gameList.forEach(gameKey => {
      const value = this.boardStatsByGame.get(gameKey)?.[property as keyof GroupedStats];
      if (typeof value === 'number') {
        total += value;
        count++;
      }
    });
    return count > 0 ? total / count : 0;
  }

  async showLocationEndDates(salesRep: SalesRep) {
    try {
      // Get all locations for this sales rep
      const salesRepLocations = this.location.filter(loc => 
        loc.salesRep?.id === salesRep.id && 
        loc.enabled === true
      );

      // Sort locations by end date (earliest first)
      const sortedLocations = salesRepLocations.sort((a, b) => {
        const dateA = a.locationEndDate ? new Date(a.locationEndDate).getTime() : Number.MAX_VALUE;
        const dateB = b.locationEndDate ? new Date(b.locationEndDate).getTime() : Number.MAX_VALUE;
        return dateA - dateB;
      });

      const modalRef = this.modalService.open(this.locationEndDatesModal, {
        size: 'lg',
        scrollable: true
      });

      this.selectedSalesRep = salesRep;
      this.selectedSalesRepLocations = sortedLocations;
    } catch (error) {
      console.error('Error fetching location end dates:', error);
      this.toastr.error('Failed to fetch location end dates');
    }
  }

  formatDate(date: string | null): string {
    if (!date) return 'No End Date Set';
    
    // Parse the date and adjust for timezone
    const parsedDate = new Date(date);
    // Add the timezone offset to get the correct date
    parsedDate.setMinutes(parsedDate.getMinutes() + parsedDate.getTimezoneOffset());
    
    return parsedDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC' // Force UTC to prevent additional timezone adjustments
    });
  }

  isDateApproaching(date: string | null): boolean {
    if (!date) return false;
    const endDate = new Date(date);
    const today = new Date();
    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 30 && diffDays > 0;
  }

  isDateExpired(date: string | null): boolean {
    if (!date) return false;
    return new Date(date) < new Date();
  }

  getTotalMonthlyPayment(): number {
    const reps = this.getActiveMetricSalesReps();
    if (!Array.isArray(reps) || !this.isFreeMonth) return 0;
  
    return reps.reduce((total, rep) => {
      const isFree = this.isFreeMonth?.[rep.id];
      const payment = isFree ? 0 : this.getAdjustedMonthlyPayment(rep);
      return total + payment;
    }, 0);
  }
  
getTotalAmountPaid(): number {
  return this.getActiveMetricSalesReps().reduce((sum, rep) => sum + this.getPaidForRep(rep), 0);
}

getTotalAmountOwed(): number {
  return Math.max(0, this.getTotalMonthlyPayment() - this.getTotalAmountPaid());
}


  
  getTotalMachines(): number {
    return this.salesReps.reduce((total, rep) => total + this.getAdjustedBoardCount(rep), 0);
  }
  onCustomDaysChange(salesRep: SalesRep) {
    const days = this.customDays[salesRep.id];
    if (days > 0) {
      salesRep.monthlyPayment = this.calculateTotal(salesRep);
      this.recalculateTotals();
      this.cdr.detectChanges();
    }
  }
  
  
async onFreeMonthChange(salesRep: SalesRep) {
  if (!salesRep?.id) return;

  const isFreeMonth = this.isFreeMonth[salesRep.id];

  try {
    if (isFreeMonth) {
      const alreadyFree = await this.paymentService.hasFreeMonthForCurrentPeriod(salesRep.id);
      if (alreadyFree) {
        this.toastr.warning('Free month already applied for this period');
        this.isFreeMonth[salesRep.id] = false;
        this.recalculateTotals();
        this.cdr.markForCheck();
        return;
      }

      const payment = await this.paymentService.recordPayment(
        salesRep.id,
        0,
        'Promotional Month',
        true
      );

      const now = new Date();
      const updatedPayments = await this.paymentService.getPaymentsByPeriod(
      salesRep.id,
      now.getFullYear(),
      now.getMonth() + 1
    );
      this.currentMonthPayments[salesRep.id] = updatedPayments;


      this.toastr.success('Promotional month applied successfully');
    }

    // Refresh totals
    this.recalculateTotals();
    this.cdr.markForCheck();

  } catch (error) {
    console.error('Error handling free month:', error);
    this.toastr.error('Failed to process promotional month');

    this.isFreeMonth[salesRep.id] = false;
    this.recalculateTotals();
    this.cdr.markForCheck();
  }
}
resetCalculations(salesRep: SalesRep) {
  this.isFreeMonth[salesRep.id] = false;
  this.customDays[salesRep.id] = 0;
  this.recalculateTotals();
}
  public getAdjustedBoardCount(salesRep: SalesRep): number {
    // Return the total boards directly, without any adjustments
    return salesRep.numBoards || 0;
}

  private calculateTotals(): void {
    // Preserve business logic: sum all reps' paid amounts
    // this.totalAmountPaid = this.salesReps
    //   .reduce((sum, rep) => sum + this.getTotalPaidAmount(rep), 0);
    this.totalMonthlyPayment = this.salesReps.reduce((sum, rep) => sum + this.getAdjustedMonthlyPayment(rep), 0);
    this.totalNumBoards = this.salesReps.reduce((sum, rep) => sum + this.getAdjustedBoardCount(rep), 0);
    this.cdr.markForCheck();
  }



  getAdjustedMonthlyPayment(salesRep: SalesRep): number {
    if (!salesRep) return 0;
    
    // If it's a free month, return 0
    if (this.isFreeMonth[salesRep.id]) {
      return 0;
    }

    const boardCount = this.getAdjustedBoardCount(salesRep);
    if (boardCount <= 0) return 0;

    const dailyRate = salesRep.tenDollarEnabled ? 10 : (salesRep.fiveDollarEnabled ? 5 : 0);
    if (dailyRate <= 0) return 0;
    
    // Use custom days if set, otherwise use days in month
    const days = this.customDays[salesRep.id] || this.daysInMonth;
    if (days <= 0) return 0;
    
    return boardCount * dailyRate * days;
  } 

  setMonthToDate() {
    const today = new Date();

    // Set start date to first day of current month
    this.statsStartDate = {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        day: 1
    };

    // Set end date to today
    this.statsEndDate = {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        day: today.getDate()
    };

    // Refresh or reload your data here if needed
    this.onDateChange();
}
checkPushSubscription() {
  navigator.serviceWorker.ready
    .then(reg => reg.pushManager.getSubscription())
    .then(sub => {
      console.log('ðŸ“¦ Push subscription on device:', sub);
      alert(sub ? 'âœ… Subscribed to push!' : 'ðŸš« Not subscribed to push notifications.');
    })
    .catch(err => {
      console.error('Failed to check push subscription:', err);
      alert('âŒ Error checking subscription.');
    });
}

triggerPush() {
  alert('ðŸ”” Button clicked'); // test if click is even working
  this.notificationService.requestPushSubscription();
}

openBoardGameStatsModal(boardStatsId: string, modalRef: any): void {
  this.selectedBoardAssetTag = this.filteredStats.find(s => s.id === boardStatsId)?.board?.assetTag || 'N/A';
  this.isLoadingGameStats = true;
  this.boardGameStatsList = [];

  this.boardGameStatsService.getByBoardStatsId(boardStatsId)
  .then(stats => {
    this.boardGameStatsList = stats;
    this.isLoadingGameStats = false;
  }).catch(error => {
    console.error('Error loading board game stats', error);
    this.isLoadingGameStats = false;
  });

  this.modalService.open(modalRef, { size: 'lg' });
}

async openLiveBoardGameStatsModal(item: FusionConnectDailyStat, modalRef: any): Promise<void> {
  const matchedBoard = this.findFortuneBoard(item);
  const boardId = item.boardId || matchedBoard?.id;
  this.selectedBoardAssetTag = item.assetTag || item.serialNumber || matchedBoard?.assetTag || 'N/A';
  this.isLoadingGameStats = true;
  this.boardGameStatsList = [];

  this.modalService.open(modalRef, { size: 'lg' });

  const fallbackRow = {
    gameStatsId: { boardStatsId: boardId || 'live', gameId: 1 },
    game: { id: 1, gameId: 1, gameName: this.getFortuneGameName(item) || 'Unknown' },
    coinInDiff: Number(item.coinIn || 0),
    coinOutDiff: Number(item.coinOut || 0),
    gamePlayedDiff: Number(item.gamesPlayed || 0),
    gameWonDiff: Number(item.gamesWon || 0),
  } as any;

  try {
    if (boardId) {
      const liveGameMeters = await this.fusionConnectService.fetchGameMetersForBoardDay({
        boardId,
        date: this.toDayKey(item.statDate),
        cashIn: Number(item.cashIn || 0),
        cashOut: Number(item.cashOut || 0),
        coinIn: Number(item.coinIn || 0),
        coinOut: Number(item.coinOut || 0),
        gamesPlayed: Number(item.gamesPlayed || 0),
        gamesWon: Number(item.gamesWon || 0),
      });

      if (liveGameMeters?.length) {
        this.boardGameStatsList = this.mapLiveGameMetersToBoardGameStats(liveGameMeters, boardId);
        return;
      }

      const liveStats = await this.boardGameStatsService.getLiveByBoardDay({
        boardId,
        date: this.toDayKey(item.statDate),
        cashIn: Number(item.cashIn || 0),
        cashOut: Number(item.cashOut || 0),
        coinIn: Number(item.coinIn || 0),
        coinOut: Number(item.coinOut || 0),
        gamesPlayed: Number(item.gamesPlayed || 0),
        gamesWon: Number(item.gamesWon || 0),
      });

      if (liveStats?.length) {
        this.boardGameStatsList = liveStats as any;
        return;
      }
    }

    const candidates = this.getRegularStatCandidatesForLive(item).slice(0, 8);
    const options: Array<{ score: number; rows: any[] }> = [];
    const collectedRows: any[] = [];

    for (const stat of candidates) {
      if (!stat?.id) continue;
      const rows = await this.boardGameStatsService.getByBoardStatsId(stat.id);
      if (rows?.length) {
        collectedRows.push(...rows);
        options.push({ score: this.scoreBoardGameStatsRows(rows, item), rows });
      }
    }

    if (collectedRows.length > 1) {
      const mergedRows = this.mergeBoardGameStatsRows(collectedRows);
      options.push({ score: this.scoreBoardGameStatsRows(mergedRows, item), rows: mergedRows });
    }

    if (options.length) {
      options.sort((a, b) => a.score - b.score);
      this.boardGameStatsList = options[0].rows;
      return;
    }

    if (boardId) {
      const latestBoardStat = await this.boardStatsService.getLatestByBoardId(boardId);
      if (latestBoardStat?.id) {
        const latestStats = await this.boardGameStatsService.getByBoardStatsId(latestBoardStat.id);
        if (latestStats?.length) {
          this.boardGameStatsList = latestStats;
          return;
        }
      }
    }

    this.boardGameStatsList = [fallbackRow];
  } catch (error) {
    console.error('Error loading live board game stats', error);
    this.boardGameStatsList = [fallbackRow];
  } finally {
    this.isLoadingGameStats = false;
    this.cdr.markForCheck();
  }
}

private mapLiveGameMetersToBoardGameStats(rows: FusionConnectGameMeterRow[], boardId: string): BoardGameStats[] {
  return (rows || []).map((row, index) => ({
    gameStatsId: {
      boardStatsId: boardId,
      gameId: index + 1,
    },
    game: {
      id: index + 1,
      gameId: index + 1,
      gameName: row.gameName || 'Unknown',
    } as any,
    coinInDiff: Number(row.coinIn || 0),
    coinOutDiff: Number(row.coinOut || 0),
    gamePlayedDiff: Number(row.gamesPlayed || 0),
    gameWonDiff: Number(row.gamesWon || 0),
  }));
}

private toDayKey(value: any): string {
  const raw = (value || '').toString();
  const parsed = Date.parse(raw);
  return Number.isFinite(parsed) ? new Date(parsed).toISOString().slice(0, 10) : raw.slice(0, 10);
}

private buildLiveRowMatchScore(item: FusionConnectDailyStat, stat: BoardStatsWithRaw): number {
  const liveDay = this.toDayKey(item.statDate);
  const statDay = this.toDayKey(stat?.timeStamp || stat?.__rawTs || '');
  const sameDayPenalty = liveDay && statDay === liveDay ? 0 : 1000000;

  const deltas = [
    Math.abs(Number(stat?.cashInDiff || 0) - Number(item?.cashIn || 0)),
    Math.abs(Number(stat?.cashOutDiff || 0) - Number(item?.cashOut || 0)),
    Math.abs(Number(stat?.coinInDiff || 0) - Number(item?.coinIn || 0)),
    Math.abs(Number(stat?.coinOutDiff || 0) - Number(item?.coinOut || 0)),
    Math.abs(Number(stat?.gamePlayedDiff || 0) - Number(item?.gamesPlayed || 0)),
    Math.abs(Number(stat?.gameWonDiff || 0) - Number(item?.gamesWon || 0)),
  ];

  return sameDayPenalty + deltas.reduce((sum, value) => sum + value, 0);
}

private getRegularStatCandidatesForLive(item: FusionConnectDailyStat): BoardStatsWithRaw[] {
  const boardId = this.normalizeId(item.boardId || '');
  const assetTag = (item.assetTag || '').trim().toLowerCase();
  const serial = (item.serialNumber || '').trim().toLowerCase();
  const liveDay = this.toDayKey(item.statDate);

  const candidates = (this._allBoardStatsRaw || this.boardStats || []).filter((stat) => {
    const statBoardId = this.normalizeId(stat?.board?.id || '');
    const statAsset = (stat?.board?.assetTag || '').trim().toLowerCase();
    const statSerial = (stat?.board?.serialNumber || '').trim().toLowerCase();

    return (!!boardId && statBoardId === boardId)
      || (!!assetTag && statAsset === assetTag)
      || (!!serial && statSerial === serial);
  });

  const sameDayCandidates = liveDay
    ? candidates.filter(stat => this.toDayKey(stat?.timeStamp || stat?.__rawTs || '') === liveDay)
    : candidates;

  const pool = sameDayCandidates.length ? sameDayCandidates : candidates;
  return pool.sort((a, b) => this.buildLiveRowMatchScore(item, a) - this.buildLiveRowMatchScore(item, b));
}

private mergeBoardGameStatsRows(rows: any[]): any[] {
  const grouped = new Map<string, any>();

  for (const row of rows || []) {
    const key = `${row?.game?.gameId || row?.gameStatsId?.gameId || ''}::${row?.game?.gameName || 'Unknown'}`;

    if (!grouped.has(key)) {
      grouped.set(key, {
        gameStatsId: row?.gameStatsId,
        game: row?.game,
        coinInDiff: 0,
        coinOutDiff: 0,
        gamePlayedDiff: 0,
        gameWonDiff: 0,
      });
    }

    const acc = grouped.get(key)!;
    acc.coinInDiff += Number(row?.coinInDiff || 0);
    acc.coinOutDiff += Number(row?.coinOutDiff || 0);
    acc.gamePlayedDiff += Number(row?.gamePlayedDiff || 0);
    acc.gameWonDiff += Number(row?.gameWonDiff || 0);
  }

  return Array.from(grouped.values()).sort((a, b) => Number(b.coinInDiff || 0) - Number(a.coinInDiff || 0));
}

private scoreBoardGameStatsRows(rows: any[], item: FusionConnectDailyStat): number {
  const totalCoinIn = (rows || []).reduce((sum, row) => sum + Number(row?.coinInDiff || 0), 0);
  const totalCoinOut = (rows || []).reduce((sum, row) => sum + Number(row?.coinOutDiff || 0), 0);
  const totalGamesPlayed = (rows || []).reduce((sum, row) => sum + Number(row?.gamePlayedDiff || 0), 0);
  const totalGamesWon = (rows || []).reduce((sum, row) => sum + Number(row?.gameWonDiff || 0), 0);

  return Math.abs(totalCoinIn - Number(item?.coinIn || 0))
    + Math.abs(totalCoinOut - Number(item?.coinOut || 0))
    + Math.abs(totalGamesPlayed - Number(item?.gamesPlayed || 0))
    + Math.abs(totalGamesWon - Number(item?.gamesWon || 0));
}

getBoardGameStatsTotals() {
  let totalCoinIn = 0;
  let totalCoinOut = 0;
  let totalGamesPlayed = 0;
  let totalGamesWon = 0;

  this.boardGameStatsList.forEach(stat => {
    totalCoinIn += stat.coinInDiff || 0;
    totalCoinOut += stat.coinOutDiff || 0;
    totalGamesPlayed += stat.gamePlayedDiff || 0;
    totalGamesWon += stat.gameWonDiff || 0;
  });

  const netProfit = totalCoinIn - totalCoinOut;
  const avgBet = totalGamesPlayed > 0 ? totalCoinIn / totalGamesPlayed : 0;
  const winRatio = totalGamesPlayed > 0 ? (totalGamesWon / totalGamesPlayed) * 100 : 0;
  const rpt = totalCoinIn > 0 ? (totalCoinOut / totalCoinIn) * 100 : 0;

  return {
    totalCoinIn,
    totalCoinOut,
    netProfit,
    totalGamesPlayed,
    totalGamesWon,
    winRatio,
    rpt,
    avgBet
  };
}
getTotalCoinIn(): number {
  return this.boardGameStatsList.reduce((sum, s) => sum + (s.coinInDiff || 0), 0);
}

getTotalCoinOut(): number {
  return this.boardGameStatsList.reduce((sum, s) => sum + (s.coinOutDiff || 0), 0);
}

getTotalNet(): number {
  return this.getTotalCoinIn() - this.getTotalCoinOut();
}

getTotalGamesPlayed(): number {
  return this.boardGameStatsList.reduce((sum, s) => sum + (s.gamePlayedDiff || 0), 0);
}

getTotalGamesWon(): number {
  return this.boardGameStatsList.reduce((sum, s) => sum + (s.gameWonDiff || 0), 0);
}

getTotalWinRatio(): number {
  const played = this.getTotalGamesPlayed();
  return played ? (this.getTotalGamesWon() / played) * 100 : 0;
}

getTotalRPT(): number {
  const coinIn = this.getTotalCoinIn();
  return coinIn ? (this.getTotalCoinOut() / coinIn) * 100 : 0;
}

getAvgBet(): number {
  const played = this.getTotalGamesPlayed();
  return played ? this.getTotalCoinIn() / played : 0;
}

private recalculateTotals() {
  this.totalMonthlyPayment = this.salesReps
    .map(rep => this.getAdjustedMonthlyPayment(rep))
    .reduce((sum, val) => sum + val, 0);
}

async loadSummaries(): Promise<void> {
  const startDate = this.statsStartDate
    ? new Date(this.statsStartDate.year, this.statsStartDate.month - 1, this.statsStartDate.day)
    : new Date(new Date().getFullYear(), new Date().getMonth(), 1); // default to 1st of this month

  const endDate = this.statsEndDate
    ? new Date(this.statsEndDate.year, this.statsEndDate.month - 1, this.statsEndDate.day)
    : new Date(); // default to today

  const start = startDate.toISOString().slice(0, 10);
  const end = endDate.toISOString().slice(0, 10);



  try {
    const summaries = await this.paymentService.getPaymentSummaries(start, end);
    
    // Inject monthlyPayment using your existing logic
  for (const summary of summaries) {
  const salesRep = this.salesReps.find(rep => rep.id === summary.salesRepId);

  summary.monthlyPayment = summary.freeMonth 
    ? 0
    : salesRep
      ? this.calculateTotal(salesRep)
      : 0;

  const payment: Payment = {
    id: '',
    salesRepId: summary.salesRepId,
    amount: summary.totalAmount,
    paymentDate: new Date(),
    periodStart: new Date(start),
    periodEnd: new Date(end),
    status: summary.totalAmount === 0
      ? 'PENDING'
      : summary.totalAmount < summary.monthlyPayment!
        ? 'PARTIAL'
        : 'PAID',
    isFreeMonth: !!summary.freeMonth,
  };

  this.currentMonthPayments[summary.salesRepId] = [payment];

  this.isFreeMonth[summary.salesRepId] = !!summary.freeMonth;
}

  } catch (err) {
    console.error('Failed to load summaries', err);
  }
}

async loadPaymentsForAllReps(): Promise<void> {
  this.isLoading = true;
  this.currentMonthPayments = {};
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;

  for (const rep of this.salesReps) {
    try {
      const payments = await this.paymentService.getPaymentsByPeriod(rep.id, year, month);
      this.currentMonthPayments[rep.id] = payments;
    } catch (err) {
      console.error(`Failed to load payments for ${rep.firstName} ${rep.lastName}`, err);
      this.currentMonthPayments[rep.id] = [];
    }
  }

  this.isLoading = false;
}

calculateMonthlyForSummary(item: PaymentSummary): number {
  const rep = this.salesReps.find(r => r.id === item.salesRepId);
  const isFree = this.isFreeMonth[item.salesRepId] || item.freeMonth || false;
  const customDays = this.customDays[item.salesRepId] || this.daysInMonth;
  const boardCount = rep?.numBoards || 0;

  return this.calculateMonthlyPayment(
    item.salesRepId,
    boardCount,
    rep?.tenDollarEnabled || false,
    rep?.fiveDollarEnabled || false,
    isFree,
    customDays
  );
}


private calculateMonthlyPayment(repId: string, boardCount: number, tenEnabled: boolean, fiveEnabled: boolean, isFree: boolean, customDays: number): number {
  if (isFree) return 0;

  const days = customDays || this.daysInMonth;
  const dailyRate = tenEnabled ? 10 : (fiveEnabled ? 5 : 0);

  return boardCount * dailyRate * days;
}

get totalAmountPaid(): number {
  const payments = Object.values(this.currentMonthPayments || {}).flat(); // safe fallback
  return payments.reduce((sum, p: any) => sum + (p.amount || 0), 0);
}

normalizeId(id: string): string {
  return id?.replace(/-/g, '').toLowerCase();
}
async loadLeads(): Promise<void> {
  try {
    this.leads = await firstValueFrom(this.leadService.getAll());
    this.filteredLeads = this.leads; // âœ… Apply default filter
  } catch (err) {
    console.error('Error loading leads', err);
  }
}

saveLead(lead: LeadDTO): void {
  this.isLoading = true;        // ðŸ”„ Start loading spinner for card (not table)
  this.showLeadsTable = false;  // â›”ï¸ Hide table while updating

  const finalize = () => {
    this.filterStatus = '';
    this.applyStatusFilter();
    this.showLeadModal = false;
    this.selectedLead = null;

    // ðŸ•’ Delay briefly so the card updates before showing table
    setTimeout(() => {
      this.isLoading = false;       // âœ… Stop card spinner
      this.showLeadsTable = true;   // âœ… Reveal the table again
    }, 200);
  };

  if (lead.id) {
    this.leadService.update(lead.id, lead).subscribe({
      next: (updated) => {
        const index = this.filteredLeads.findIndex(l => l.id === updated.id);
        if (index !== -1) this.filteredLeads[index] = updated;
        finalize();
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.isLoading = false;
      }
    });
  } else {
    this.leadService.create(lead).subscribe({
      next: (newLead) => {
        this.filteredLeads.push(newLead);
        this.totalLeads += 1;  // âœ… Optional: update the card count
        finalize();
      },
      error: (err) => {
        console.error('Create failed:', err);
        this.isLoading = false;
      }
    });
  }
}

openLeadModal(): void {
  this.showLeadsTable = false;     // ðŸ”´ Hide the table first
  this.selectedLead = null;        // Clear any prefilled lead
  this.showLeadModal = true;       // âœ… Show the modal last
}



editLead(lead: LeadDTO): void {
  this.showLeadsTable = false;     // Hide the table
  this.selectedLead = lead;        // Pass selected lead to modal
  this.showLeadModal = true;       // Show modal
}


deleteLead(id: string): void {
  if (confirm('Are you sure?')) {
    this.leadService.delete(id).subscribe(() => this.loadLeads());
  }
}

getSalesRepName(id: string): string {
  if (!id || id === 'new-rep') {
    return 'Potential New Sales Rep';
  }

  const rep =
    this.salesReps.find(r => r.id === id) ||
    this.allSalesReps.find(r => r.id === id);
  return rep
    ? [rep.firstName, rep.lastName].filter(Boolean).join(' ') || rep.username || id
    : 'Unknown Rep';
}

loadTotalLeads() {
  this.leadService.getLeadCount().subscribe(count => {
    this.totalLeads = count;
  });
}

applyStatusFilter(): void {
  this.filteredLeads = this.filterStatus
    ? this.leads.filter(l => l.status === this.filterStatus)
    : [...this.leads]; // âœ… clone the array to force update
}

private async loadTopGameStats() {
  try {
    const loadId = ++this.topGameLoadId;
    let topGames = await this.boardGameStatsService.getTopGames(
      this.formatDateForApi(this.startDate),  // e.g. 2025-07-01
      this.formatDateForApi(this.endDate),     // e.g. 2025-07-31
      this.getActiveTopGameSalesRepId()
    );
    topGames = this.mergeTopGamesByName(topGames);
    this.allTopGameStats = topGames;
    this.topGameStats = topGames;
    // Let the downstream pipeline pick the winner once all breakdown data returns
    await this.computeFilteredTotalsForTopGames(loadId);
  } catch (error) {
    console.error('Error loading top game stats:', error);
  }
}


// This one is for sending to backend
formatDateForApi(date: Date): string {
  return date.toISOString().split('T')[0];
}

openGameStatsModal(): void {
  this.showGameStatsModal = true;
}
async loadGameBreakdown(gameName: string): Promise<void> {
  if (this.expandedGameName === gameName) { this.expandedGameName = null; return; }

  const key   = this.norm(gameName);
  const names = Array.from(this.mergedNameMap.get(key) ?? [gameName]);
  const start = this.startDate.toISOString();
  const end   = this.endDate.toISOString();

  // fetch summaries for each name
  const lists = await Promise.all(
    names.map(n =>
      firstValueFrom(this.boardGameStatsService.getBoardSummary(n, start, end))
        .catch(() => [])
    )
  );

  // ðŸš« flatten + remove any Warehouse rows
  const rows = this.filterBreakdownRows(lists.flat() as any[]);

  // merge by board
  const merged = new Map<string, { summary: any; details: any[] }>();

  for (const r of rows) {
    const k   = `${r.boardAssetTag}::${r.boardSerialNumber}`;
    const pkg = this.pkgByAssetTag[r.boardAssetTag] || '';

    let ex = merged.get(k);
    if (!ex) {
      ex = {
        summary: {
          boardAssetTag: r.boardAssetTag,
          boardSerialNumber: r.boardSerialNumber,
          locationName: r.locationName,
          salesRepName: r.salesRepName,
          coinIn: Number(r.coinIn || 0),
          coinOut: Number(r.coinOut || 0),
          net: Number(r.coinIn || 0) - Number(r.coinOut || 0),
          gamesPlayed: Number(r.gamesPlayed || 0),
          gamesWon: Number(r.gamesWon || 0),
          installedGamePackage: pkg
        },
        details: []
      };
      merged.set(k, ex);
    } else {
      ex.summary.coinIn      += Number(r.coinIn || 0);
      ex.summary.coinOut     += Number(r.coinOut || 0);
      ex.summary.net          = ex.summary.coinIn - ex.summary.coinOut;
      ex.summary.gamesPlayed += Number(r.gamesPlayed || 0);
      ex.summary.gamesWon    += Number(r.gamesWon || 0);
    }
  }

  // build UI model
  this.selectedGroupedBreakdowns[gameName] = Array.from(merged.values())
    .map(v => ({ summary: v.summary, details: v.details, expanded: false }))
    .sort((a, b) => b.summary.coinIn - a.summary.coinIn);

  this.expandedGameName = gameName;
  this.cdr.markForCheck();
}








async loadBoardSummary(gameName: string): Promise<void> {
  const start = this.startDate.toISOString();
  const end = this.endDate.toISOString();

  this.boardGameStatsService.getBoardSummary(gameName, start, end).subscribe(summary => {
    this.boardSummariesByGame[gameName] = summary;
  });
}

async expandBoard(boardTag: string, gameName: string): Promise<void> {
  if (this.readBreakdownsByBoard[boardTag]) {
    this.expandedBoards.delete(boardTag);
    delete this.readBreakdownsByBoard[boardTag];
    return;
  }

  const start = this.startDate.toISOString();
  const end = this.endDate.toISOString();

  this.boardGameStatsService.getDetailedBreakdown(gameName, start, end).subscribe(breakdown => {
    this.readBreakdownsByBoard[boardTag] = breakdown.filter(r => r.boardAssetTag === boardTag);
    this.expandedBoards.add(boardTag);
  });
}

groupByBoard(details: GameStatsDetails[]): Record<string, GameStatsDetails[]> {
  const grouped: Record<string, GameStatsDetails[]> = {};

  for (const entry of details) {
    const key = `${entry.boardAssetTag}::${entry.boardSerialNumber}`;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(entry);
  }

  // Sort each boardâ€™s entries by descending timestamp
  Object.values(grouped).forEach(entries => {
    entries.sort((a, b) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime());
  });

  return grouped;
}


groupDetailsByBoard(stats: GameStatsDetails[]): [string, { summary: GameStatsDetails, details: GameStatsDetails[] }][] {
  const grouped = new Map<string, { summary: GameStatsDetails, details: GameStatsDetails[] }>();

  for (const item of stats) {
    const key = `${item.boardAssetTag}_${item.boardSerialNumber}`;
    const existing = grouped.get(key);

    if (!existing) {
      grouped.set(key, {
        summary: {
          boardAssetTag: item.boardAssetTag,
          boardSerialNumber: item.boardSerialNumber,
          locationName: item.locationName,
          salesRepName: item.salesRepName,
          coinIn: item.coinIn,
          coinOut: item.coinOut,
          net: item.net,
          gamesPlayed: item.gamesPlayed,
          gamesWon: item.gamesWon,
          timeStamp: '', // leave out in summary
          daysSincePrevRead: 0,
          gameName: item.gameName,
          installedGamePackage: item.installedGamePackage || '',
        },
        details: [item],
      });
    } else {
      existing.summary.coinIn += item.coinIn;
      existing.summary.coinOut += item.coinOut;
      existing.summary.net += item.net;
      existing.summary.gamesPlayed += item.gamesPlayed;
      existing.summary.gamesWon += item.gamesWon;
      existing.details.push(item);
    }
  }

  // Sort each detail array by timeStamp descending
  for (const entry of grouped.values()) {
    entry.details.sort((a, b) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime());
  }

  return Array.from(grouped.entries());
}


loadStatsForGame(gameName: string) {
  const start = this.startDate.toISOString();
  const end = this.endDate.toISOString();

  this.boardGameStatsService.getDetailedBreakdown(gameName, start, end).subscribe(data => {
    const grouped = this.groupDetailsByBoard(data);
    this.groupedGameStats = grouped.map(([boardKey, { summary, details }]) => ({
      boardKey,
      summary,
      details,
      expanded: false,
    }));
  });
}

getPaidForRep(rep: SalesRep): number {
  if (!rep?.id) return 0;

  // 1) Prefer the summary map built from /payment-summaries
  const key = this.normalizeId(rep.id);
  const fromSummary = this.totalPaid?.[key];
  if (typeof fromSummary === 'number') return fromSummary;

  // 2) Fallback to summing this monthâ€™s payments (excl. free months)
  const payments = this.currentMonthPayments?.[rep.id] ?? [];
  return payments
    .filter(p => !p.isFreeMonth && (p.status === 'PAID' || p.status === 'PARTIAL'))
    .reduce((sum, p) => sum + (p.amount || 0), 0);
}

  private rebuildStatesList() {
    const fromLocations = (this.location || [])
      .map(l => (l?.businessAddress?.state || '').trim().toUpperCase())
      .filter(Boolean);

    const fromStats = (this.boardStats || [])
      .map(s => (s?.__state || '').trim().toUpperCase())
      .filter(Boolean);

  this.states = Array.from(new Set([...fromLocations, ...fromStats])).sort();
}

onStateFilterChange() {
  if (this.activeFilterContext === 'live') {
    this.updateFortuneLiveSummary();
    this.cdr.detectChanges();
    return;
  }

  this.applyAllFilters(this.term);
}
private prefetchPackagesForTopGames() {
  if (!this.topGameStats?.length) {
    this.packageByGame = {};
    return;
  }
  const start = this.startDate.toISOString();
  const end   = this.endDate.toISOString();

  this.packageByGame = {};
  for (const g of this.topGameStats) {
    const key = this.norm(g.gameName);
    const rawNames = Array.from(this.mergedNameMap.get(key) ?? [g.gameName]);

    (async () => {
      const lists = await Promise.all(
        rawNames.map(n =>
          firstValueFrom(this.boardGameStatsService.getGameBreakdown(n, start, end))
            .catch(() => [])
        )
      );

      const allRows = this.filterBreakdownRows(lists.flat() as any[]);
      const counts: Record<string, number> = {};
      for (const r of allRows || []) {
        const tag = (r as any).boardAssetTag;
        const pkg =
          (r as any).installedPackageName ||
          (r as any).gamePackageName ||
          (r as any).packageName ||
          this.pkgByAssetTag[tag];
        if (pkg) counts[pkg] = (counts[pkg] || 0) + 1;
      }

      const top = Object.entries(counts).sort((a,b) => b[1]-a[1])[0]?.[0];
      const alias = this.packageAliasByNormKey[key];
      this.packageByGame[g.gameName] = alias || top || 'N/A';
      this.cdr.markForCheck();
    })();
  }
}


private buildCoinPerDay(rows: GameStatsBreakdown[]) {
  const byBoard = new Map<string, {
    boardAssetTag: string;
    boardSerialNumber: string;
    locationName: string;
    salesRepName: string;
    coinInTotal: number;
    days: number;
  }>();

  for (const r of rows || []) {
    const tag = r.boardAssetTag;
    if (!tag) continue;
    if (!byBoard.has(tag)) {
      byBoard.set(tag, {
        boardAssetTag: r.boardAssetTag,
        boardSerialNumber: r.boardSerialNumber,
        locationName: r.locationName,
        salesRepName: r.salesRepName,
        coinInTotal: 0,
        days: 0,
      });
    }
    const acc = byBoard.get(tag)!;
    acc.coinInTotal += Number(r.coinIn || 0);

    // count only positive day deltas to avoid div-by-zero noise
    const d = Number(r.daysSincePrevRead || 0);
    if (d > 0) acc.days += d;
  }

  const arr = Array.from(byBoard.values()).map(b => ({
    ...b,
    coinPerDay: b.days > 0 ? b.coinInTotal / b.days : 0,
  }));

  // best â†’ worst
  arr.sort((a, b) => b.coinPerDay - a.coinPerDay);
  return arr;
}

private avgFromBreakdown(rows: GameStatsBreakdown[]): number {
  const filtered = (rows || []).filter(r => !this.isWarehouseRow(r));
  const byBoard = new Map<string, { coin: number; days: number }>();

  for (const r of filtered) {
    const key = r.boardAssetTag || r.boardSerialNumber || '';
    if (!key) continue;
    if (!byBoard.has(key)) byBoard.set(key, { coin: 0, days: 0 });
    const acc = byBoard.get(key)!;
    acc.coin += Number(r.coinIn || 0);
    const d = Number(r.daysSincePrevRead || 0);
    if (d > 0) acc.days += d;
  }

  const perBoard = Array.from(byBoard.values()).map(b => (b.days > 0 ? b.coin / b.days : 0));
  return perBoard.length ? perBoard.reduce((s, v) => s + v, 0) / perBoard.length : 0;
}

private loadAvgCoinPerDayForAllGames(loadId?: number): Promise<void> {
  if (!this.topGameStats?.length) {
    this.avgCoinPerDayByGame = {};
    this.topGamePerDay = null;
    this.avgCoinPerDayLoading = false;
    this.cdr.markForCheck();
    return Promise.resolve();
  }

  const start = this.startDate.toISOString();
  const end   = this.endDate.toISOString();
  this.avgCoinPerDayLoading = true;
  this.avgCoinPerDayByGame = {};

  const obs = this.topGameStats.map(g =>
    this.boardGameStatsService
      .getGameBreakdown(g.gameName, start, end)
      .pipe(map(rows => this.avgFromBreakdown(this.filterBreakdownRows(rows))))
  );

  return new Promise(resolve => {
    forkJoin(obs).subscribe({
      next: values => {
        if (loadId && loadId !== this.topGameLoadId) { resolve(); return; } // stale response guard
        this.topGameStats.forEach((g, i) => {
          this.avgCoinPerDayByGame[g.gameName] = values[i];
        });

        // ðŸ‘‰ pick the winner & (optionally) resort after we have the true averages
        this.updateTopGamePerDay();
        this.sortTopGamesByAvgCoin();

        this.avgCoinPerDayLoading = false;
        this.cdr.markForCheck();
        resolve();
      },
      error: () => {
        if (loadId && loadId !== this.topGameLoadId) { resolve(); return; } // stale response guard
        this.avgCoinPerDayLoading = false;
        this.cdr.markForCheck();
        resolve();
      }
    });
  });
}




private sortTopGamesByAvgCoin(): void {
  this.topGameStats.sort((a, b) => {
    const avgDiff =
      (this.avgCoinPerDayByGame[b.gameName] ?? 0) -
      (this.avgCoinPerDayByGame[a.gameName] ?? 0);
    if (avgDiff !== 0) return avgDiff;

    const boardDiff =
      (this.boardsPerGame[b.gameName] ?? 0) -
      (this.boardsPerGame[a.gameName] ?? 0);
    if (boardDiff !== 0) return boardDiff;

    return this.norm(a.gameName).localeCompare(this.norm(b.gameName));
  });

  // keep topGame in sync with the sorted list
  this.topGame = this.topGameStats.length ? this.topGameStats[0] : null;
}

// assumes you already have helpers + map from the merge step:
//   this.norm(name: string)
//   this.mergedNameMap: Map<string, Set<string>>

private async fillBoardCountsForTopGames(): Promise<void> {

  if (!this.topGameStats?.length) {

    this.boardsPerGame = {};

    return;

  }



  const start = this.startDate.toISOString();

  const end = this.endDate.toISOString();

  this.boardsPerGame = {};



  const results = await Promise.all(

    this.topGameStats.map(async g => {

      const key = this.norm(g.gameName);

      const rawNames = Array.from(this.mergedNameMap.get(key) ?? [g.gameName]);



      const lists = await Promise.all(

        rawNames.map(n =>

          firstValueFrom(this.boardGameStatsService.getBoardSummary(n, start, end)).catch(() => [])

        )

      );



      const filtered = this.filterBreakdownRows(lists.flat() as any[]);



      const unique = new Set<string>();

      for (const r of filtered) {

        unique.add(`${r.boardAssetTag}::${r.boardSerialNumber}`);

      }



      return { name: g.gameName, count: unique.size };

    })

  );



  for (const { name, count } of results) this.boardsPerGame[name] = count;

  this.sortTopGamesByAvgCoin();

  this.cdr.markForCheck();

}






private mergeTopGamesByName(games: GameAggregateStats[]): GameAggregateStats[] {
  this.mergedNameMap.clear();
  const map = new Map<string, GameAggregateStats>();

  for (const g of games) {
    const key = this.norm(g.gameName);
    if (!this.mergedNameMap.has(key)) this.mergedNameMap.set(key, new Set());
    this.mergedNameMap.get(key)!.add(g.gameName);

    const ex = map.get(key);
    if (!ex) {
      // clone, normalize display name
      map.set(key, { ...g, gameName: this.pretty(g.gameName) });
    } else {
      // sum metrics across variants with the same normalized name
      ex.totalCoinIn      = (Number(ex.totalCoinIn)     || 0) + (Number(g.totalCoinIn)     || 0);
      ex.totalCoinOut     = (Number(ex.totalCoinOut)    || 0) + (Number(g.totalCoinOut)    || 0);
      ex.netProfit        = (Number(ex.netProfit)       || 0) + (Number(g.netProfit)       || 0);
      ex.totalGamesPlayed = (Number(ex.totalGamesPlayed)|| 0) + (Number(g.totalGamesPlayed)|| 0);
      ex.totalGamesWon    = (Number(ex.totalGamesWon)   || 0) + (Number(g.totalGamesWon)   || 0);
    }
  }

  return Array.from(map.values());
}


// --- name utils
private norm(name: string): string {
  const trimmed = (name || '').trim().replace(/\s+/g, ' ').toLowerCase();
  const alias: Record<string, string> = {
    'mega treasure': 'world of wonders',
    'worldwonderclassic': 'world of wonders',
    'worldwondersclassic': 'world of wonders',
    'worldwonder classic': 'world of wonders',
    'world of wonders classic': 'world of wonders',
    'fortune ip three liner': 'fortune ip three liner',
    'fortuneipthreeliner': 'fortune ip three liner',
    'fortune ip 3 liner': 'fortune ip three liner'
  };
  return alias[trimmed] || trimmed;
}
private pretty(name: string): string {
  return (name || '').trim().replace(/\s+/g, ' ');
}



async onToggleBoardGroup(boardGroup: any, gameName: string) {
  boardGroup.expanded = !boardGroup.expanded;
  if (!boardGroup.expanded || (boardGroup.details?.length ?? 0) > 0) return;

  const key   = this.norm(gameName);
  const names = Array.from(this.mergedNameMap.get(key) ?? [gameName]);
  const start = this.startDate.toISOString();
  const end   = this.endDate.toISOString();

  const lists = await Promise.all(
    names.map(n => firstValueFrom(
      this.boardGameStatsService.getDetailedBreakdown(n, start, end)
    ).catch(() => []))
  );

  const all = this.filterBreakdownRows(lists.flat())
    .filter(d => d.boardAssetTag === boardGroup.summary.boardAssetTag)
    .sort((a,b) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime());

  boardGroup.details = all;
  this.cdr.markForCheck();
}

private isWarehouseRow(r: any): boolean {
  const rep = (r?.salesRepName || r?.salesRep || '').toString().toLowerCase();
  const loc = (r?.locationName || '').toString().toLowerCase();
  return rep.includes('warehouse') || loc.includes('warehouse');
}

private pickFirstString(list: Array<string | undefined | null>): string {
  return (list.find(v => !!(v && v.toString().trim())) || '').toString().trim();
}

private pickNonWarehouse(list: Array<string | undefined | null>): string | undefined {
  return list
    .map(v => (v || '').toString().trim())
    .find(v => v && !this.isWarehouseName(v));
}

private buildStatMeta(stat: any): BoardStatsWithRaw {
  const locationCandidates = [
    stat?.board?.location?.locationName,
    stat?.board?.currentDeployment?.location?.locationName,
    stat?.locationName,
    stat?.location,
  ];

  const repCandidates = [
    `${stat?.board?.location?.salesRep?.firstName || ''} ${stat?.board?.location?.salesRep?.lastName || ''}`,
    `${stat?.board?.currentDeployment?.location?.salesRep?.firstName || ''} ${stat?.board?.currentDeployment?.location?.salesRep?.lastName || ''}`,
    stat?.salesRepName,
    stat?.salesRep,
  ];
  const repIds = [
    stat?.board?.location?.salesRep?.id,
    stat?.board?.currentDeployment?.location?.salesRep?.id,
  ];

  const stateCandidates = [
    stat?.board?.location?.businessAddress?.state,
    stat?.board?.currentDeployment?.location?.businessAddress?.state,
    stat?.state,
  ];

  const locationName = this.pickNonWarehouse(locationCandidates) ?? this.pickFirstString(locationCandidates);
  const salesRepName = this.pickNonWarehouse(repCandidates) ?? this.pickFirstString(repCandidates);
  const state = this.pickFirstString(stateCandidates);

  const isWarehouse =
    this.isWarehouseName(locationName) ||
    this.isWarehouseName(salesRepName) ||
    this.isWarehouseName(this.pickFirstString(locationCandidates)) ||
    this.isWarehouseName(this.pickFirstString(repCandidates));

  return {
    ...stat,
    __rawTs: stat?.timeStamp ?? stat?.time_stamp ?? stat?.timestamp ?? '',
    __serial: stat?.board?.serialNumber ?? stat?.serialNumber ?? stat?.board?.serial_number ?? '',
    __locationName: locationName || 'Unknown',
    __salesRepName: salesRepName || 'Unknown',
    __salesRepId: this.pickFirstString(repIds),
    __state: state || '',
    __isWarehouse: !!isWarehouse,
  };
}

private computeFilteredTotalsForTopGames(loadId?: number): Promise<void> {
  const games = this.allTopGameStats?.length ? this.allTopGameStats : this.topGameStats;
  if (!games?.length) {
    this.topGameStats = [];
    this.resetTopGameDerived();
    return Promise.resolve();
  }

  const start = this.startDate.toISOString();
  const end = this.endDate.toISOString();

  const obs = games.map(g => {
    const key = this.norm(g.gameName);
    const names = Array.from(this.mergedNameMap.get(key) ?? [g.gameName]);

    const requests = names.map(n =>
      this.boardGameStatsService
        .getGameBreakdown(n, start, end)
        .pipe(catchError(() => of([] as GameStatsBreakdown[])))
    );

    return forkJoin(requests).pipe(
      map((lists: GameStatsBreakdown[][]) => {
        const filtered = this.filterBreakdownRows((lists || []).flat());
        const coinIn = filtered.reduce((s, r) => s + Number(r.coinIn || 0), 0);
        const coinOut = filtered.reduce((s, r) => s + Number(r.coinOut || 0), 0);
        return {
          name: g.gameName,
          coinIn,
          coinOut,
          net: coinIn - coinOut,
          fallbackCoinIn: Number(g.totalCoinIn || 0),
          fallbackCoinOut: Number(g.totalCoinOut || 0),
          fallbackNet: Number(g.netProfit || 0),
          hasRows: filtered.length > 0
        };
      })
    );
  });

  return new Promise(resolve => {
    forkJoin(obs).subscribe({
      next: async results => {
        // drop stale responses from a previous refresh
        if (loadId && loadId !== this.topGameLoadId) { resolve(); return; }

        const visible = new Set<string>();
        this.cleanTotalsByGame = {};

        for (const r of results) {
          if (r.hasRows) visible.add(r.name);
          this.cleanTotalsByGame[r.name] = r.hasRows
            ? { coinIn: r.coinIn, coinOut: r.coinOut, net: r.net }
            : {
                coinIn: r.fallbackCoinIn,
                coinOut: r.fallbackCoinOut,
                net: r.fallbackNet
              };
        }

        this.topGameStats = games.filter(g => visible.has(g.gameName));
        this.topGame = this.topGameStats.length ? this.topGameStats[0] : null;

        if (!this.topGameStats.length) {
          this.resetTopGameDerived();
          this.cdr.markForCheck();
          resolve();
          return;
        }

        await this.loadAvgCoinPerDayForAllGames(loadId);
        await this.fillBoardCountsForTopGames();
        this.prefetchPackagesForTopGames();
        this.buildTopGamesChart();
        this.cdr.markForCheck();
        resolve();
      },
      error: () => {
        this.cdr.markForCheck();
        resolve();
      }
    });
  });
}

private isWarehouseName(s?: string): boolean {
  return !!s && s.toString().toLowerCase().includes('warehouse');
}

  private isWarehouseRowLoose(row: any): boolean {
    // covers both location and sales rep variations
    return this.isWarehouseName(row?.locationName) ||
           this.isWarehouseName(row?.location)     ||
           this.isWarehouseName(row?.salesRepName) ||
           this.isWarehouseName(row?.salesRep);
  }
  private boardInventoryLocationKey(loc?: Location | null): string {
    return (
      loc?.id ||
      loc?.locationTag ||
      loc?.locationName ||
      ''
    )
      .toString()
      .toLowerCase();
  }

  private boardInventoryLocationKeyFromBoard(board: Board): string {
    const locId = board.location?.id || board.currentDeployment?.location?.id;
    const locTag = board.location?.locationTag || board.currentDeployment?.location?.locationTag;
    const locName = board.location?.locationName || board.currentDeployment?.location?.locationName;
    return (
      locId ||
      locTag ||
      locName ||
      ''
    )
      .toString()
      .toLowerCase();
  }
  private async loadBoardInventoryBoards(): Promise<Board[]> {
    const allBoards = await this.boardService.getAll();
    if (!allBoards?.length) return [];

    const inventoryIds = new Set(this.boardInventoryLocations.map(l => l.id));

    return (allBoards || []).filter(b => {
      const locId = b.location?.id || b.currentDeployment?.location?.id;
      const locName = (b.location?.locationName || b.currentDeployment?.location?.locationName || '').toLowerCase();
      const inInventory = (locId && inventoryIds.has(locId)) || locName.includes('board inventory');
      const enabled = b.enabled !== false;
      return inInventory && enabled;
    });
  }

  private updateBoardInventoryTypeCounts(boards: Board[]): void {
    this.boardInventoryTypeCounts = {};
    this.boardInventoryTypeCountsByLocation = {};
    for (const b of boards || []) {
      const type = (b.boardType?.name || 'Unknown').trim() || 'Unknown';
      this.boardInventoryTypeCounts[type] = (this.boardInventoryTypeCounts[type] || 0) + 1;

      const locKey = this.boardInventoryLocationKeyFromBoard(b);
      if (locKey) {
        if (!this.boardInventoryTypeCountsByLocation[locKey]) {
          this.boardInventoryTypeCountsByLocation[locKey] = {};
        }
        this.boardInventoryTypeCountsByLocation[locKey][type] =
          (this.boardInventoryTypeCountsByLocation[locKey][type] || 0) + 1;
      }
    }

    const countFromBoards = boards?.length ?? 0;
    this.boardInventoryTotalBoards = countFromBoards > 0 ? countFromBoards : this.boardInventoryTotalBoards;
  }

  getBoardTypeCountsForLocation(loc: Location): Array<{ type: string; count: number }> {
    const key = this.boardInventoryLocationKey(loc);
    const counts = this.boardInventoryTypeCountsByLocation[key] || {};
    return Object.entries(counts).map(([type, count]) => ({ type, count }));
  }


private tagOf(row: any): string {
  return (row?.boardAssetTag ?? row?.assetTag ?? row?.boardTag ?? '').toString().trim();
}
private serialOf(row: any): string {
  return (row?.boardSerialNumber ?? row?.serialNumber ?? row?.serial ?? '').toString().trim();
}

private getActiveBoardKeySets(): { assetTags: Set<string>; serials: Set<string>; restrict: boolean } {
  const hasFiltered = Array.isArray(this.filteredStats);
  const source = hasFiltered ? (this.filteredStats || []) : (this.boardStats || []);

  const assetTags = new Set<string>();
  const serials = new Set<string>();

  for (const s of source) {
    const tag = (s?.board?.assetTag ?? (s as any)?.assetTag ?? '').toString().toLowerCase();
    const serial = (s?.board?.serialNumber ?? (s as any)?.serialNumber ?? '').toString().toLowerCase();
    if (tag) assetTags.add(tag);
    if (serial) serials.add(serial);
  }

  return { assetTags, serials, restrict: hasFiltered };
}

private matchesActiveBoardSelection(assetTag?: string, serial?: string): boolean {
  const { assetTags, serials, restrict } = this.getActiveBoardKeySets();
  if (!restrict) return true;
  if (!assetTags.size && !serials.size) return false;

  const tag = (assetTag || '').toString().toLowerCase();
  const ser = (serial || '').toString().toLowerCase();
  return (!!tag && assetTags.has(tag)) || (!!ser && serials.has(ser));
}

private filterBreakdownRows<T extends { boardAssetTag?: string; boardSerialNumber?: string }>(rows: T[]): T[] {
  const { assetTags, serials, restrict } = this.getActiveBoardKeySets();
  const cleaned = (rows || []).filter(r =>
    !this.isWarehouseRow(r) && !this.isExcludedFortuneRouteRow(r)
  );
  if (!restrict) return cleaned;
  if (!assetTags.size && !serials.size) return [];

  return cleaned.filter(r => {
    const tag = (r.boardAssetTag || '').toString().toLowerCase();
    const serial = (r.boardSerialNumber || '').toString().toLowerCase();
    return (tag && assetTags.has(tag)) || (serial && serials.has(serial));
  });
}

private isExcludedFortuneRouteRow(row: any): boolean {
  const salesRepName = this.normalizeScopedName(row?.salesRepName || row?.salesRep);
  const locationName = this.normalizeScopedName(row?.locationName || row?.location);

  if (this.fusionLeaseSalesReps.some(name =>
    this.normalizeScopedName(name) === salesRepName
  )) return true;

  if (this.pickupLocations.some(name => {
    const normalized = this.normalizeScopedName(name);
    return normalized === salesRepName || normalized === locationName;
  })) return true;

  if (salesRepName === 'rahim visram') return true;

  const knownLocation = (this.location || []).find(location =>
    this.normalizeScopedName(location.locationName) === locationName
  );
  return !!knownLocation && this.isSalesOutlet(knownLocation);
}

private resetTopGameDerived(): void {
  this.topGamePerDay = null;
  this.avgCoinPerDayByGame = {};
  this.boardsPerGame = {};
  this.packageByGame = {};
  this.cleanTotalsByGame = {};
  this.avgCoinPerDayLoading = false;
}

private updateTopGamePerDay(): void {
  const allowedNames = new Set((this.topGameStats || []).map(g => g.gameName));
  const displayByNorm = new Map<string, string>();
  for (const g of this.topGameStats || []) {
    displayByNorm.set(this.norm(g.gameName), g.gameName);
  }

  const aggregates: { key: string; avg: number; display: string; boards: number }[] = [];

  for (const [name, avg] of Object.entries(this.avgCoinPerDayByGame)) {
    if (!allowedNames.has(name) || !Number.isFinite(avg) || avg <= 0) continue;

    const key = this.norm(name);
    const display = displayByNorm.get(key) || this.pretty(name);
    aggregates.push({
      key,
      avg,
      display,
      boards: this.boardsPerGame[name] ?? 0
    });
  }

  if (!aggregates.length) {
    this.topGamePerDay = null;
    this.cdr.markForCheck();
    return;
  }

  aggregates.sort((a, b) => {
    if (b.avg !== a.avg) return b.avg - a.avg;
    if (b.boards !== a.boards) return b.boards - a.boards;
    return a.key.localeCompare(b.key);
  });

  const winner = aggregates[0];
  this.topGamePerDay = { gameName: winner.display, avg: winner.avg };
  this.cdr.markForCheck();
}

// Assuming you already have: locations: Location[]; filteredLocations: Location[];
// Use this computed array in the template: *ngFor="let location of displayLocations"

get displayLocations(): Location[] {
  const base = this.filteredLocations?.length ? this.filteredLocations : this.location || [];
  const filtered = base
    .filter(loc => this.isFortuneRouteLocation(loc))
    .filter(loc => {
      const city = (loc.businessAddress?.city || '').toString().toLowerCase();
      const state = (loc.businessAddress?.state || '').toString().toLowerCase();
      const machines = loc.numBoards || 0;

      const cityMatch = !this.locationCityFilter ||
        city.includes(this.locationCityFilter.toLowerCase().trim());
      const stateMatch = !this.locationStateFilter ||
        state === this.locationStateFilter.toLowerCase().trim();
      const machinesMatch =
        this.locationMinMachines === null ||
        machines >= (this.locationMinMachines || 0);

      return cityMatch && stateMatch && machinesMatch;
    });

  if (this.locationSortColumn) {
    const dir = this.locationSortAsc ? 1 : -1;
    filtered.sort((a, b) => {
      if (this.locationSortColumn === 'machines') {
        return ((a.numBoards || 0) - (b.numBoards || 0)) * dir;
      }
      if (this.locationSortColumn === 'city') {
        return ((a.businessAddress?.city || '').localeCompare(b.businessAddress?.city || '')) * dir;
      }
      if (this.locationSortColumn === 'state') {
        return ((a.businessAddress?.state || '').localeCompare(b.businessAddress?.state || '')) * dir;
      }
      return 0;
    });
  }

  return filtered;
}

private isSalesOutlet(loc: Location): boolean {
  const v = (loc as any)?.salesOutlet;
  // Treat true/1/'1'/'true' as sales outlet
  return v === true || v === 1 || v === '1' || v === 'true';
}

  private parsePrice(value: any): number | null {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  /** Returns the board price for a sales-outlet location, falling back to the global default. */
  getSalesOutletBoardPrice(loc: Location): number {
    const candidate =
      this.parsePrice((loc as any)?.salesOutletBoardPrice) ??
      this.parsePrice((loc as any)?.customBoardPrice) ??
      this.parsePrice((loc as any)?.boardPrice);

    return candidate ?? this.salesOutletBoardPrice;
  }

  /** Computed total for a single sales-outlet row. */
  getSalesOutletRowTotal(loc: Location): number {
    return (loc.numBoards || 0) * this.getSalesOutletBoardPrice(loc);
  }

  /** Whether the board sale has been paid for this location. */
  isSalesOutletPaid(loc: Location): boolean {
    const v = (loc as any)?.salesOutletPaid ?? (loc as any)?.paid ?? (loc as any)?.isPaid;
    return v === true || v === 1 || v === '1' || v === 'true' || `${v}`.toLowerCase() === 'paid';
  }

  /** Amount paid toward the board sale for this location. */
  getSalesOutletPaidAmount(loc: Location): number {
    const n = Number((loc as any)?.salesOutletPaidAmount ?? (loc as any)?.paidAmount ?? (loc as any)?.amountPaid);
    return Number.isFinite(n) ? n : 0;
  }

  get salesOutletLocations(): Location[] {
    const rows = (this.location || []).filter(loc => this.isSalesOutlet(loc));
    return this.hasActiveDashboardFilters()
      ? rows.filter(loc => this.matchesDashboardLocationFilters(loc))
      : rows;
  }

  get displayedContractedBoardsCount(): number {
    if (!this.hasActiveDashboardFilters()) return this.contractedBoardsCount;

    const keys = new Set<string>();

    for (const item of this.filteredStats || []) {
      const key = (item?.board?.id || item?.board?.assetTag || item?.board?.serialNumber || item?.id || '').toString().trim().toLowerCase();
      if (key) keys.add(key);
    }

    for (const item of this.filteredFortuneLiveStats || []) {
      const key = (item?.boardId || item?.assetTag || item?.serialNumber || '').toString().trim().toLowerCase();
      if (key) keys.add(key);
    }

    return keys.size;
  }

  get displayedBoardInventoryLocations(): Location[] {
    return this.hasActiveDashboardFilters()
      ? (this.boardInventoryLocations || []).filter(loc => this.matchesDashboardLocationFilters(loc))
      : (this.boardInventoryLocations || []);
  }

  get displayedBoardInventoryTotalBoards(): number {
    return this.displayedBoardInventoryLocations.reduce((sum, loc) => sum + (loc.numBoards || 0), 0);
  }

  get displayedWarehouseBoardsCount(): number {
    if (!this.hasActiveDashboardFilters()) return this.contractedBoardsWarehouseCount;
    return (this.filteredLocation || [])
      .filter(loc => this.matchesDashboardLocationFilters(loc))
      .reduce((sum, loc) => sum + (loc.numBoards || 0), 0);
  }

  get displayedTotalNewLocations(): number {
    if (!this.hasActiveDashboardFilters()) return this.totalNewLocations;
    return (this.filteredNewLocations || []).filter(loc => this.matchesDashboardLocationFilters(loc)).length;
  }

  get displayedTotalNewBoards(): number {
    if (!this.hasActiveDashboardFilters()) return this.totalNewBoards;
    return (this.filteredNewLocations || [])
      .filter(loc => this.matchesDashboardLocationFilters(loc))
      .reduce((sum, loc) => sum + (loc.numBoards || 0), 0);
  }

  get displayedTotalLeads(): number {
    if (!this.hasActiveDashboardFilters()) return this.totalLeads;

    const textFilter = (this.term || '').trim().toLowerCase();
    const selectedRepName = `${this.selectedSalesRep?.firstName || ''} ${this.selectedSalesRep?.lastName || ''}`.trim().toLowerCase();

    return (this.leads || []).filter((lead: any) => {
      const haystack = Object.values(lead || {}).map(v => (v || '').toString().toLowerCase()).join(' ');
      const matchesText = !textFilter || haystack.includes(textFilter);
      const matchesRep = !this.selectedSalesRep || haystack.includes(selectedRepName);
      return matchesText && matchesRep;
    }).length;
  }

  private matchesDashboardLocationFilters(loc?: Location | null): boolean {
    if (!loc) return false;

    const textFilter = (this.term || '').trim().toLowerCase();
    const boardFilter = (this.boardSearchTerm || '').trim().toLowerCase();
    const selectedState = (this.selectedState || '').trim().toLowerCase();
    const selectedRepId = this.normalizeId(this.selectedSalesRep?.id || '');
    const repId = this.normalizeId(loc?.salesRep?.id || '');
    const repName = `${loc?.salesRep?.firstName || ''} ${loc?.salesRep?.lastName || ''}`.trim().toLowerCase();
    const state = (loc?.businessAddress?.state || '').trim().toLowerCase();
    const fullText = [loc?.locationName, loc?.locationTag, repName, state]
      .map(v => (v || '').toString().toLowerCase())
      .join(' ');

    const matchesText = !textFilter || fullText.includes(textFilter);
    const matchesBoard = !boardFilter || fullText.includes(boardFilter);
    const matchesRep = !this.selectedSalesRep || (!!selectedRepId ? repId === selectedRepId : fullText.includes(repName));
    const matchesState = !selectedState || state === selectedState;

    return matchesText && matchesBoard && matchesRep && matchesState;
  }

  get locationStateOptions(): string[] {
    const states = new Set<string>();
    for (const loc of this.location || []) {
      const s = (loc.businessAddress?.state || '').toString().trim();
      if (s) states.add(s);
    }
    return Array.from(states).sort();
  }

  get salesOutletBoardsCount(): number {
    return this.salesOutletLocations.reduce((sum, loc) => sum + (loc.numBoards || 0), 0);
  }

  get salesOutletTotalValue(): number {
    return this.salesOutletLocations.reduce((sum, loc) => sum + this.getSalesOutletRowTotal(loc), 0);
  }

  /** Total paid across all sales-outlet locations (helps surface coverage vs invoice totals). */
  get salesOutletTotalPaidAmount(): number {
    return this.salesOutletLocations.reduce((sum, loc) => sum + this.getSalesOutletPaidAmount(loc), 0);
  }

  async onSalesOutletPriceChange(loc: Location, value: any): Promise<void> {
    const parsed = this.parsePrice(value);
    loc.salesOutletBoardPrice = parsed ?? undefined;
    await this.persistSalesOutletMeta(loc);
  }

  async onSalesOutletPaidAmountChange(loc: Location, value: any): Promise<void> {
    const n = Number(value);
    loc.salesOutletPaidAmount = Number.isFinite(n) && n >= 0 ? n : 0;
    await this.persistSalesOutletMeta(loc);
  }

  async onSalesOutletPaidToggle(loc: Location, paid: boolean): Promise<void> {
    loc.salesOutletPaid = paid;
    await this.persistSalesOutletMeta(loc);
  }

  /**
   * Persist minimal sales-outlet billing metadata for a location.
   * Falls back silently if the API rejects the payload.
   */
  private async persistSalesOutletMeta(loc: Location): Promise<void> {
    try {
      // The backend update endpoint expects required fields (salesRep, address, tags, etc.).
      await this.locationService.update(loc.id, {
        id: loc.id,
        locationTag: loc.locationTag,
        locationName: loc.locationName,
        locationStartDate: loc.locationStartDate,
        locationEndDate: loc.locationEndDate,
        enabled: loc.enabled,
        salesOutlet: loc.salesOutlet,
        salesOutletBoardPrice: loc.salesOutletBoardPrice,
        salesOutletPaid: loc.salesOutletPaid,
        salesOutletPaidAmount: loc.salesOutletPaidAmount,
        businessAddress: loc.businessAddress,
        salesRep: loc.salesRep, // required by backend (non-null FK)
      } as any);
      this.cdr.markForCheck();
    } catch (err) {
      console.warn('Failed to update sales outlet billing info', err);
    }
  }

private async ensureBoardStatsLoaded(force = false): Promise<void> {
  if (this.boardStatsLoading || (this.boardStatsLoaded && !force)) return;

  this.boardStatsLoading = true;
  this.cdr.markForCheck();

  try {
    const startDate = this.statsStartDate
      ? new Date(this.statsStartDate.year, this.statsStartDate.month - 1, this.statsStartDate.day, 0, 0, 0)
      : this.startDate || new Date(new Date().getFullYear(), new Date().getMonth(), 1);

    const endDate = this.statsEndDate
      ? new Date(this.statsEndDate.year, this.statsEndDate.month - 1, this.statsEndDate.day, 23, 59, 59)
      : this.endDate || new Date();

    const allBoardStats = await this.boardStatsService.getAllByDateRange(startDate, endDate);
    const withRaw = (allBoardStats || []).map((s: any) => this.buildStatMeta(s));

    this._allBoardStatsRaw = withRaw;

    if (this.loginService.userType === UserType.EXTERNAL) {
      this.boardStats = withRaw.filter(item =>
        !item.__isWarehouse && this.matchesActiveSalesRep(item.__salesRepId, item.__salesRepName)
      );
    } else {
      this.boardStats = withRaw.filter(item => {
        const firstName = item.board?.location?.salesRep?.firstName?.trim();
        const lastName = item.board?.location?.salesRep?.lastName?.trim();

        const hasValidRead =
          item.daysSincePrevRead > 0 &&
          item.daysSincePrevRead <= 70 &&
          item.cashInDiff > 0 &&
          item.cashOutDiff >= 0;

        const blockedRep =
          (firstName === 'Shiraz' && lastName === 'Salim') ||
          (firstName === 'Vijay' && lastName === 'Patel');

        return hasValidRead && !blockedRep && !item.__isWarehouse;
      });
    }

    this.pkgByAssetTag = {};
    for (const s of allBoardStats || []) {
      const loc = s.board?.location?.locationName;
      const rep = `${s.board?.location?.salesRep?.firstName || ''} ${s.board?.location?.salesRep?.lastName || ''}`;
      if (this.isWarehouseName(loc) || this.isWarehouseName(rep)) continue;

      const tag = s.board?.assetTag?.trim();
      const pkg = s.board?.installedGamePackage?.name?.trim();

      if (tag && pkg) {
        this.pkgByAssetTag[tag] = pkg;
      }
    }

    this.boardStatsLoaded = true;
    this.applyAllFilters(this.term);
  } catch (error) {
    console.error('Failed to load board stats table rows:', error);
    this.toastr.error('Failed to load board stats');
  } finally {
    this.boardStatsLoading = false;
    this.cdr.markForCheck();
  }
}

private applyAllFilters(term: string = ''): void {
  const t = (term || this.term || '').toLowerCase().trim();
  const boardTerm = (this.boardSearchTerm || '').toLowerCase().trim();

  this.filteredStats = (this.boardStats || []).filter(s => {
    const name = (s.__salesRepName || '').toLowerCase();
    const game = (s.board?.installedGamePackage?.name || '').toLowerCase();
    const location = (s.__locationName || '').toLowerCase();
    const state= (s.__state || '').toLowerCase();
    const serial = (s.__serial || '').toLowerCase();
    const assetTag = (s.board?.assetTag || '').toLowerCase();

    // text search (keeps your classic/klassic logic)
    const searchForClassic = t === 'classic';
    const searchForKlassic = t === 'klassic';
    const hasClassicVariant = game.includes('classic');
    const hasKlassicVariant = game.includes('klassic');

    let matchesTerm = true;
    if (t) {
      matchesTerm =
        game.includes(t) ||
        name.includes(t) ||
        location.includes(t) ||
        (searchForClassic && (hasClassicVariant || hasKlassicVariant)) ||
        (searchForKlassic && (hasClassicVariant || hasKlassicVariant));
    }

    const matchesRep   = !this.selectedSalesRep || s.__salesRepId === this.selectedSalesRep.id;
    const matchesState = !this.selectedState    || state === this.selectedState.toLowerCase();
    const matchesBoard = !boardTerm || serial.includes(boardTerm) || assetTag.includes(boardTerm);
    // If you later add a dedicated selectedGame filter, mirror it here:
    // const matchesGame  = !this.selectedGame || game.includes(this.selectedGame.toLowerCase());

    return matchesTerm && matchesRep && matchesState && matchesBoard; // && matchesGame
  });

  this.boardStatsByGame = this.boardStatsService.groupStatsByBoardDetails(
    this.validStats,
    this.boardStatsService.standardGameKeyFunction
  );

  if (this.hasActiveDashboardFilters()) {
    this.calculateAverages();
  }
  this.updateSalesRepsList();
  this.updateFortuneLiveSummary();
  void this.computeFilteredTotalsForTopGames();
  this.buildRptGamesChart();
  this.cdr.detectChanges();
}

getSerial = (row: any): string =>
  row?.__serial ||
  row?.board?.serialNumber ||
  row?.serialNumber ||
  row?.board?.serial_number ||
  '';

getRowTs = (row: any): string => {
  const raw = (row?.__rawTs || '').toString();
  // If it's already 'YYYY-MM-DD HH:mm:ss.SSSSSS', return as-is
  const usRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{6}$/;
  if (usRegex.test(raw)) return raw;

  // Fallback: normalize using your existing formatter
  return this.boardStatsService.formatToBackendTs(
    row?.timeStamp ?? row?.time_stamp ?? row?.timestamp ?? ''
  );
};

private formatPointDate(ts: number | null | undefined): string {
  if (!Number.isFinite(ts as number)) return '';
  return this.datePipe.transform(ts, 'MMM d, y') || '';
}

private buildRptGamesChart(): void {
  const rows = this.filteredStats || [];
  const byBoard = new Map<string, { display: string; points: Array<{ ts: number; rpt: number | null; games: number; dateLabel?: string }> }>();

  for (const row of rows) {
    const locationName =
      (row as any)?.__locationName ||
      row?.board?.location?.locationName ||
      row?.board?.currentDeployment?.location?.locationName ||
      '';
    const tag = (row?.board?.assetTag ?? row?.assetTag ?? '').toString().trim();
    const serial = this.getSerial(row);
    const boardKey = tag || serial || (row as any)?.id || (row?.board as any)?.id;
    if (!boardKey) continue;
    const display = locationName?.toString().trim() || tag || serial || 'Board';

    const tsStr = this.getRowTs(row);
    const ts = Date.parse(tsStr.replace(' ', 'T'));
    if (!Number.isFinite(ts)) continue;
    const dateLabel = this.formatPointDate(ts);

    const coinIn = Number(row?.coinInDiff ?? row?.cashInDiff ?? 0);
    const coinOut = Number(row?.coinOutDiff ?? row?.cashOutDiff ?? 0);
    const games = Number(row?.gamePlayedDiff ?? row?.gamesPlayed ?? 0);
    const rpt = coinIn > 0 ? coinOut / coinIn : null;

    if (!byBoard.has(boardKey)) {
      byBoard.set(boardKey, { display, points: [] });
    }
    byBoard.get(boardKey)!.points.push({ ts, rpt, games, dateLabel });
  }

  const series: ApexAxisChartSeries = [];

  byBoard.forEach(({ display, points }) => {
    if (points.length < 2) return; // need at least 2 points to draw a useful line
    const sorted = points.slice().sort((a, b) => a.ts - b.ts);

    const rptSeries: any[] = [];
    let cumulativeGames = 0;

    for (const p of sorted) {
      cumulativeGames += p.games || 0;
      if (p.rpt !== null && Number.isFinite(p.rpt)) {
        rptSeries.push({ x: cumulativeGames, y: p.rpt, ts: p.ts, dateLabel: p.dateLabel });
      }
    }

    if (rptSeries.length >= 2) {
      series.push({ name: display, type: 'line', data: rptSeries } as any);
    }
  });

  this.rptGamesSeries = series;
}
private async buildTopGamesChart(): Promise<void> {
  this.rptTopGamesSeries = [];
  if (!this.topGameStats?.length || !this.startDate || !this.endDate) return;

  const start = this.startDate.toISOString();
  const end = this.endDate.toISOString();
  const series: ApexAxisChartSeries = [];

  for (const g of this.topGameStats) {
    let rows: any[] = [];
    try {
      rows = await firstValueFrom(
        this.boardGameStatsService.getGameBreakdown(g.gameName, start, end)
      );
    } catch {
      rows = [];
    }

    const filtered = this.filterBreakdownRows(rows || []);
    if (!filtered.length) continue;

    const sorted = filtered
      .slice()
      .sort((a, b) => new Date(a.timeStamp).getTime() - new Date(b.timeStamp).getTime());

    let cumulativeGames = 0;
    const pts: any[] = [];
    for (const r of sorted) {
      const games = Number((r as any).gamesPlayed ?? 0);
      cumulativeGames += games;
      const coinIn = Number((r as any).coinIn ?? 0);
      const coinOut = Number((r as any).coinOut ?? 0);
      const rpt = coinIn > 0 ? coinOut / coinIn : null;
      const tsValue = Date.parse((r as any).timeStamp ?? '');
      const dateLabel = this.formatPointDate(tsValue);
      if (rpt !== null && Number.isFinite(rpt)) {
        pts.push({ x: cumulativeGames, y: rpt, ts: tsValue, dateLabel });
      }
    }

    if (pts.length >= 2) {
      series.push({ name: g.gameName, type: 'line', data: pts } as any);
    }
  }

  this.rptTopGamesSeries = series;
  this.cdr.markForCheck();
}
// Helper type: your BoardStats plus our preserved fields







deleteRow(row: any) {
  const serial = this.getSerial(row);
  const rawTs = this.getRowTs(row); // whatever shape it is in row
  const timeStamp = this.boardStatsService.formatToBackendTs(rawTs); // âœ… normalize

  if (!serial || !timeStamp) {
    alert('Missing serial or timestamp on this row.');
    return;
  }

  if (!confirm(`Delete this stat?\n${serial} @ ${timeStamp}`)) return;

  const key = `${serial}|${timeStamp}`;
  this.isDeleting[key] = true;

  this.boardStatsService.deleteOneRowBySerial(serial, timeStamp).subscribe({
    next: res => {
      if ((res.deletedBoardGameStats ?? 0) > 0 && (res.deletedBoardStats ?? 0) > 0) {
        // remove from modal list if open
        this.locationBoardStats = (this.locationBoardStats || []).filter((s: any) =>
          !(this.getSerial(s) === serial && this.getRowTs(s) === timeStamp)
        );

        // ðŸ”¥ also remove from main datasets immediately
        this.boardStats = (this.boardStats || []).filter(s =>
          !(this.getSerial(s) === serial && this.getRowTs(s) === timeStamp)
        );
        this.filteredStats = (this.filteredStats || []).filter(s =>
          !(this.getSerial(s) === serial && this.getRowTs(s) === timeStamp)
        );

        // rebuild groups + UI
        this.boardStatsByGame = this.boardStatsService.groupStatsByBoardDetails(
          this.validStats,
          this.boardStatsService.standardGameKeyFunction
        );
        this.calculateAverages();
        this.updateSalesRepsList();
        this.cdr.markForCheck();
      } else {
        alert('Nothing deleted (already removed or timestamp mismatch).');
      }
    },
    error: err => {
      console.error(err);
      alert('Delete failed.');
    },
    complete: () => delete this.isDeleting[key],
  });
}

async flagStat(stat: BoardStats) {
  const note = prompt('Enter reason for flagging:');
  if (!note) return;

  try {
    await firstValueFrom(
      this.boardStatsService.flagStat(stat.id, true, note)
    );

    stat.manuallyFlagged = true;
    stat.flaggedNote = note;

    this.toastr.warning('Stat flagged');
    await this.refresh();

  } catch (e) {
    console.error(e);
    this.toastr.error('Failed to flag stat');
  }
}

async unflagStat(stat: BoardStats) {
  try {
    await firstValueFrom(
      this.boardStatsService.flagStat(stat.id, false, '')
    );

    stat.manuallyFlagged = false;
    stat.flaggedNote = '';

    this.toastr.success('Stat unflagged');
    await this.refresh();

  } catch (e) {
    console.error(e);
    this.toastr.error('Failed to unflag stat');
  }
}

// Gate button to ROOT (adjust to your auth service)
get isRoot(): boolean {
  return (this.loginService?.user?.userType || '').toUpperCase() === 'ROOT';
}

isFlaggedStat(stat: BoardStats | null | undefined): boolean {
  const value = stat?.manuallyFlagged as any;
  return value === true || value === 1 || value === '1' || `${value}`.toLowerCase() === 'true';
}

get validStats(): BoardStatsWithRaw[] {
  return (this.filteredStats || []).filter(
    s => !this.isFlaggedStat(s) && !this.isDedicatedCardStat(s)
  );
}

private isLeaseAllocatedLocation(loc: Location): boolean {
  const repName = `${loc?.salesRep?.firstName || ''} ${loc?.salesRep?.lastName || ''}`;
  const normalizedRep = this.normalizeScopedName(repName);
  return this.fusionLeaseSalesReps.some(
    name => this.normalizeScopedName(name) === normalizedRep
  );
}

private isBoardSalesAllocatedLocation(loc: Location): boolean {
  const repName = `${loc?.salesRep?.firstName || ''} ${loc?.salesRep?.lastName || ''}`;
  return this.isSalesOutlet(loc) || this.normalizeScopedName(repName) === 'rahim visram';
}

private isFortuneRouteLocation(loc: Location): boolean {
  const enabled = this.isEnabledLocation(loc);
  const hasBoards = Number(loc?.numBoards || 0) > 0;
  const isWarehouse =
    this.isWarehouseName(loc?.locationName) ||
    this.isWarehouseName(`${loc?.salesRep?.firstName || ''} ${loc?.salesRep?.lastName || ''}`);

  return enabled &&
    hasBoards &&
    !isWarehouse &&
    !this.isLeaseAllocatedLocation(loc) &&
    !this.isBoardSalesAllocatedLocation(loc);
}

async moveStatTo(stat: BoardStats, destination: 'fusionLease' | 'pickup'): Promise<void> {
  const category = destination === 'fusionLease' ? 'FUSION_LEASE' : 'PICKUP';
  await this.moveStatToCategory(stat, category);
}

async moveStatToCategory(
  stat: BoardStats,
  category: 'STANDARD' | 'FUSION_LEASE' | 'PICKUP' | 'BOARD_SALES'
): Promise<void> {
  const label = category === 'FUSION_LEASE'
    ? 'Fusion Lease'
    : category === 'PICKUP'
      ? 'Locations to Pick Up'
      : category === 'BOARD_SALES'
        ? 'Board Sales'
        : 'Board Stats';
  if (!confirm(`Move this stat to ${label}?`)) return;

  try {
    await firstValueFrom(this.boardStatsService.updateCategory(stat.id, category));
    stat.statsCategory = category;
    this.toastr.success(`Stat moved to ${label}`);
    await this.refresh();
    await this.ensureBoardStatsLoaded(true);
  } catch (e) {
    console.error(e);
    this.toastr.error(`Failed to move stat to ${label}`);
  }
}

private formatLocalDateOnly(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

async onDedicatedFlagChange(event: { stat: BoardStats; flagged: boolean }): Promise<void> {
  if (event.flagged) {
    await this.flagStat(event.stat);
  } else {
    await this.unflagStat(event.stat);
  }
  await this.ensureBoardStatsLoaded(true);
}

get flaggedStats(): BoardStatsWithRaw[] {
  return (this.filteredStats || []).filter(
    s => this.isFlaggedStat(s) && !this.isDedicatedCardStat(s)
  );
}



}
